// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:34:16.846Z
// Property: McAlister (ID: 5682633027616768)
// Collections: 20 amenities, 10 floorplans (live), 29 photos, 80 POIs, 3 reviews, 5 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5682633027616768",
  "property_external_id": "4600727",
  "property_zillow_url": "https://www.zillow.com/apartments/webster-tx/450-el-dorado-blvd/5XhsDC/",
  "property_apartments_url": "https://www.apartments.com/mcalister-webster-tx/x10e3rp",
  "property_google_business_url": "https://www.google.com/maps/place/McAlister/@29.5599294,-95.1452834,17z/data=!4m13!1m7!3m6!1s0x86409d694b45cb13:0x6c221d519a9794b0!2s450+El+Dorado+Blvd,+Webster,+TX+77598!3b1!8m2!3d29.5599294!4d-95.1430894!3m4!1s0x86409b87868cab89:0x520d77c640622841!8m2!3d29.5589705!4d-95.1428071",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443872082",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "mcalister",
  "property_name": "McAlister",
  "property_website_url": "https://www.mcalisterliving.com/",
  "property_domain": "https://www.mcalisterliving.com/",
  "property_address": "450 El Dorado Blvd",
  "property_full_address": "450 El Dorado Blvd, Webster, TX 77598",
  "property_address_1": "450 El Dorado Blvd",
  "property_address_2": null,
  "property_address_city": "Webster",
  "property_address_state": "TX",
  "property_address_zip_full": "77598-2317",
  "property_address_zip": "77598",
  "property_address_country": "US",
  "property_address_county": "Harris County",
  "property_neighborhood_address": "Clear Lake",
  "property_address_latitude": "29.5589655",
  "property_address_longitude": "-95.1428811",
  "property_email": "mcalister@alapts.com",
  "property_phone": "(281) 480-3303",
  "property_call_tracking_phone": "346-658-0569",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Live close to the best of Clear Lake.</strong> McAlister pairs easygoing one- and two-bedroom apartment living with relaxed community spaces and a connected Webster location—explore the floor plans and see what feels like home.</p>",
  "property_long_description": "<p><strong>Live close to the best of Clear Lake.</strong> McAlister places you in Webster with quick access to I-45, Baybrook Mall, Space Center Houston, and the NASA Johnson Space Center area, while keeping everyday conveniences close along El Dorado Boulevard and Bay Area Boulevard. Browse one- and two-bedroom <a href=\"/floor-plans\">apartment floor plans</a> designed for easy living, with options that may include private patios or balconies, wood-style flooring, French doors, built-in bookcases, vaulted ceilings, fireplaces, and washer and dryer features.</p><p>At home, your routine has room to relax: take a swim in the resort-inspired pool, fit in a workout at the 24-hour fitness center, pick up packages through the resident package system, or unwind around the community gazebos and landscaped grounds. With Dad’s Club Sports Complex nearby, Baybrook dining and shopping minutes away, and Clear Lake’s aerospace, medical, and waterfront energy all within reach, McAlister gives you a comfortable Webster address with a connected <a href=\"/neighborhood\">Clear Lake lifestyle</a>.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019d02f1-3711-7697-be5c-d44e0f76be21.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style pool with lounge chairs and umbrellas, with apartment buildings in the background.",
    "public_id": "019d02f1-3711-7697-be5c-d44e0f76be21",
    "storage_key": "property/5682633027616768/019d02f1-3711-7697-be5c-d44e0f76be21.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "214",
  "property_year_built": "1989",
  "property_year_renovated": "2020",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.92523364485982",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $300 / pet\nRefundable Pet Deposit $200 per pet\nMonthly Pet Rent $25 / pet\nApplication Approval Fee Starting At $300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, refundable pet deposit of $200 per pet, with a monthly pet rent of $20 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, refundable pet deposit of $200 per pet, with a monthly pet rent of $20 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8113533.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://mcalister.loftliving.com/login",
  "property_apply_now_url": "https://8113533.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e6fdd-175d-70ec-a9ef-bb514eaa19e5.webp",
  "property_primary_logo_media": {
    "alt_text": "McAlister Premier Apartments Logo",
    "public_id": "019e6fdd-175d-70ec-a9ef-bb514eaa19e5",
    "storage_key": "property/5682633027616768/019e6fdd-175d-70ec-a9ef-bb514eaa19e5.webp",
    "width": 1121,
    "height": 790
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e6fdd-172a-7736-860b-40d513e9b5ef.webp",
  "property_secondary_logo_media": {
    "alt_text": "Red stylized M logo",
    "public_id": "019e6fdd-172a-7736-860b-40d513e9b5ef",
    "storage_key": "property/5682633027616768/019e6fdd-172a-7736-860b-40d513e9b5ef.webp",
    "width": 1126,
    "height": 806
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e6fdd-1698-739c-84a2-4f42290a6811.webp",
  "property_icon_media": {
    "alt_text": "The property's abstract logo, featuring an 'M' shape in rust and blue.",
    "public_id": "019e6fdd-1698-739c-84a2-4f42290a6811",
    "storage_key": "property/5682633027616768/019e6fdd-1698-739c-84a2-4f42290a6811.webp",
    "width": 826,
    "height": 827
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e6fdd-1698-739c-84a2-4f42290a6811.webp",
  "property_fav_icon_media": {
    "alt_text": "The property's abstract logo, featuring an 'M' shape in rust and blue.",
    "public_id": "019e6fdd-1698-739c-84a2-4f42290a6811",
    "storage_key": "property/5682633027616768/019e6fdd-1698-739c-84a2-4f42290a6811.webp",
    "width": 826,
    "height": 827
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f42f6-7e34-7531-91cb-1de6bd92b19a.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f42f6-7e34-7531-91cb-1de6bd92b19a",
    "storage_key": "property/5682633027616768/019f42f6-7e34-7531-91cb-1de6bd92b19a.webp",
    "width": 1121,
    "height": 790
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f42f6-67cf-72cd-a1f5-5cf4345266b3.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f42f6-67cf-72cd-a1f5-5cf4345266b3",
    "storage_key": "property/5682633027616768/019f42f6-67cf-72cd-a1f5-5cf4345266b3.webp",
    "width": 1121,
    "height": 790
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#81392d",
  "property_secondary_color": "#1e355e",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#355698",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "552 - 1210",
  "property_sqft_min": "552",
  "property_sqft_max": "1210",
  "property_price_range": "945 - 1445",
  "property_price_min": "945",
  "property_price_max": "1445",
  "property_available_units": 13,
  "property_facebook_url": "https://www.facebook.com/McAlisterApts",
  "property_instagram_url": "https://www.instagram.com/mcalisterapts",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJiauMhoebQIYRQShiQMZ3DVI",
  "property_youtube_url": "https://www.youtube.com/watch?v=yY7zqwDrGpA",
  "property_yelp_url": "https://www.yelp.com/biz/mcalister-webster",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Comfort, streamlined.</strong> At McAlister, resort-inspired spaces and everyday conveniences make home feel effortless. Recharge by the swimming pool, keep your routine on track in the 24-hour fitness center, grab deliveries through the resident package system, or relax beneath the community gazebos. Inside, wood-style flooring, private patios or balconies, walk-in closets, and select upgrades like vaulted ceilings, fireplaces, stainless steel appliances, and in-home laundry add polish where it counts.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find a floor plan with the right kind of space.</strong> McAlister offers one- and two-bedroom apartments in Webster, TX, with layouts that range from streamlined and efficient to roomy two-bath designs. Inside, look for chef-style kitchens, premium appliances, wood-style flooring, crown molding, oversized windows, walk-in closets, and private patios or balconies—plus select upgrades like vaulted ceilings, fireplaces, built-in bookcases, French doors, stainless steel appliances, and in-home laundry features.</p>",
  "property_home_gallery_blurb": "<p><strong>See McAlister in focus.</strong> Preview sunlit living rooms with wood-style flooring, polished kitchens with stainless steel accents, and bedrooms shaped for easy downtime. Then look outside to the pool deck, shaded lounge seating, green space, and gazebos, with everyday conveniences like the fitness center, package area, and laundry spaces rounding out the view.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Clear Lake convenience, mapped your way.</strong> McAlister places you near Gulf Freeway and NASA Parkway for easy routes to Baybrook shopping, Clear Lake dining, waterfront detours, and outdoor escapes like Armand Bayou Nature Center and Challenger Seven Memorial Park. NASA Johnson Space Center, Space Center Houston, HCA Houston Healthcare Clear Lake, and University of Houston–Clear Lake are nearby, adding to the area’s everyday energy. Explore the neighborhood and see how Webster keeps plans close.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents notice the details at McAlister.</strong> Reviews point to a helpful leasing team, responsive service, clean tours, and a quiet, well-kept setting. Keondre and the staff are often mentioned by name for clear answers and quick follow-through, while the pool, maintained grounds, and comfortable atmosphere give everyday life at McAlister its easy appeal.</p>",
  "property_neighborhood_blurb": "<p><strong>Map out a Clear Lake day with options in every direction.</strong> From McAlister, you’re positioned near the Gulf Freeway and NASA Parkway, so coffee runs, errands, dinner plans, and waterfront detours all stay easy. Browse Baybrook shopping and restaurants, grab Cajun at Floyd’s or Korean BBQ at KPOT near Clear Lake Center, then trade the pavement for trails and bayou scenery at Armand Bayou Nature Center or Challenger Seven Memorial Park.</p><p>The neighborhood’s aerospace-and-medical energy is part of the rhythm here, with NASA Johnson Space Center, Space Center Houston, HCA Houston Healthcare Clear Lake, and University of Houston–Clear Lake nearby. Explore the map, then see how McAlister connects comfortable apartment living with one of Webster’s most convenient Clear Lake locations when you <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Put comfort on autopilot.</strong> At McAlister, everyday conveniences and resort-inspired spaces work together in Webster. Break up the day with a swim, fit in a workout at the 24-hour fitness center, pick up deliveries through the resident package system, or unwind beneath the community gazebos. Inside, details like wood-style flooring, private patios or balconies, two-inch blinds, and walk-in closets give your home a polished, practical feel, while select apartments add vaulted ceilings, wood-burning fireplaces, built-in bookcases, stainless steel appliances, USB outlets, double vanities, or in-home laundry. Explore the <a href=\"/gallery\">amenity photos</a>, compare your favorite finishes, and <a href=\"/schedule-a-tour\">schedule a tour</a> to see how McAlister supports your routine from morning to night.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make McAlister home?</strong> Choose an easy-living one- or two-bedroom apartment in Webster, with comfortable features and relaxing community spaces that keep daily routines simple. Start your online application today and take the next step toward a connected Clear Lake lifestyle.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Reach out to the McAlister leasing team for help with apartment availability, floor plan details, and getting here. We’re happy to connect you with the information you need for easy living in Webster near Clear Lake.</p>",
  "property_faqs_blurb": "<p><strong>Questions about McAlister?</strong> Start here for quick answers about the community, leasing, apartment features, and everyday living in Webster near Clear Lake. If you need more details or help choosing your next step, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the space that fits your day.</strong> McAlister’s one- and two-bedroom apartments in Webster range from efficient, easy-to-maintain layouts to larger two-bath designs with room to spread out. Compare each floor plan by layout, price, and availability, then look for the details that make a home feel finished: chef-style kitchens with premium appliances, wood-style flooring, crown molding, oversized windows, walk-in closets, and private patios or balconies.</p><p>Select homes add extra character with vaulted ceilings, built-in bookcases, French doors, fireplaces, double bathroom vanities, stainless steel appliances, USB outlets, or in-home laundry features. Explore the <a href=\"/amenities\">apartment features</a>, then choose your favorite layout and <a href=\"/schedule-a-tour\">schedule a tour</a> to see how it lives in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture the rhythm of McAlister before you arrive.</strong> Scroll through the gallery to see the details that give these Webster apartments their easy, polished feel: sunlit living rooms with wood-style flooring, kitchens with clean finishes and stainless steel accents, and bedrooms framed for calm, comfortable downtime.</p><p>Outside, the camera moves from the pool deck and shaded lounge seating to open green space, gazebos, and spots made for a slower afternoon. You’ll also get a look at practical everyday spaces, from the fitness center to package and laundry conveniences. After you’ve found the views and finishes that stand out, compare layouts on the <a href=\"/floor-plans\">floor plans</a> page or <a href=\"/schedule-a-tour\">schedule a tour</a> to see McAlister in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore McAlister on the map.</strong> See available one- and two-bedroom apartments and get a feel for the connected Clear Lake location near I-45, Baybrook Mall, Space Center Houston, and everyday conveniences along El Dorado Boulevard and Bay Area Boulevard.</p>",
  "property_pets_blurb": "<p><strong>Room to roam, nap, and feel at home.</strong> At McAlister, cats and dogs are welcome with no weight limit, so your pet-friendly apartment search in Webster can focus on comfort instead of compromise. Step outside for an easy stroll through the community’s designated pet-friendly walking area, then come back to a home with practical touches like wood-style flooring, spacious closets, and available private patios or balconies that make everyday pet routines simpler.</p><p>From quick potty breaks to weekend supply runs, life here keeps the essentials close without overcomplicating your day. Explore the <a href=\"/amenities\">pet-friendly community features</a>, compare layouts with room for your pet’s favorite sunny spot, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see McAlister in person.</p>",
  "property_referafriend_blurb": "<p><strong>Share life at McAlister.</strong> If you love the easy Webster location, relaxed community spaces, and comfortable <a href=\"/floor-plans\">one- and two-bedroom floor plans</a>, invite a friend to experience it too. Send a referral and help them discover a connected Clear Lake lifestyle close to everyday conveniences.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at McAlister.</strong><br>Use your resident portal to pay rent, submit maintenance requests, and manage account details with ease—so you can get back to enjoying your Webster apartment and the everyday convenience of life near Clear Lake.</p>",
  "property_reviews_blurb": "<p><strong>See what stands out at McAlister.</strong> In resident reviews and tour feedback, you’ll notice the same themes come up again and again: a welcoming team, attentive service, and a property that feels clean, quiet, and well cared for.</p><p>Reviewers often call out Keondre and the McAlister staff for being helpful, knowledgeable, and quick to answer questions or handle requests. Others mention the pool, the kept-up grounds, and the comfortable atmosphere as reasons they enjoy the community. From “very clean” tours to management that is “quick to resolve any service requests,” these reviews offer a real look at everyday life at McAlister.</p>",
  "property_created_at": "1752256499560",
  "property_scheduletour_blurb": "<p><strong>See McAlister in person.</strong> Tour one- and two-bedroom apartments with easy-living details like private patios or balconies, wood-style flooring, vaulted ceilings, fireplaces, and washer and dryer features. Then picture your routine with a resort-inspired pool, 24-hour fitness center, and landscaped spaces close to Clear Lake conveniences. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong> The McAlister leasing team will follow up soon. In the meantime, picture easy Webster living with comfortable one- and two-bedroom layouts, relaxing community spaces, and everyday convenience close to home.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you stop by.</strong> Explore McAlister from wherever you are with virtual tours that bring key spaces into focus. Start with the community tour, then take a closer look at the pool and fitness center to picture how the amenities connect to your day-to-day routine. Inside the apartment walkthroughs, compare select one-bedroom layouts and a two-bedroom layout, noticing the flow from living areas to kitchens, bedrooms, closets, and private outdoor space where shown.</p><p>Use these tours to narrow your favorites, then visit <a href=\"/floor-plans\">floor plans</a> for current layouts or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience McAlister in Webster in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Mcalister",
  "property_seo_title_home": "Mcalister | Apartments in Webster, TX",
  "property_seo_description_home": "Discover your dream apartment at Mcalister in Webster, TX! Choose from spacious one and two-bedroom floor plans featuring top-notch amenities like a fitness center, pool, and covered parking. Enjoy the elegance of tall ceilings, cozy fireplaces, and the convenience of in-unit laundry connections. Experience a vibrant community with online resident services, a gazebo, and beautiful courtyard views. Don’t wait—find your new home today at Mcalister!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Webster, TX",
  "property_seo_description_floorplans": "Discover your ideal living space at Mcalister in Webster, TX! Explore our thoughtfully designed floor plans featuring cozy one-bedroom and spacious two-bedroom apartments. Browse our available options to find the perfect fit for your lifestyle. Your dream apartment awaits!",
  "property_seo_title_amenities": "Amenities | Webster, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover your perfect home at McAlister in Webster, TX! Explore spacious one and two-bedroom floor plans featuring built-in bookcases, tall ceilings, and modern kitchen appliances. Enjoy our exceptional amenities including a fitness center, pool, covered parking, and a cozy gazebo. With online resident services and convenient W&D connections, you'll love the comfort and convenience of our community. Experience the lifestyle you deserve—explore our amazing amenities today!",
  "property_seo_title_gallery": "Gallery | Apartments in Webster, TX",
  "property_seo_description_gallery": "Discover your dream apartment at Mcalister in Webster, TX. Explore our stunning photo gallery showcasing spacious one and two-bedroom floor plans, featuring modern amenities like a state-of-the-art fitness center, covered parking, and relaxing pool views. Enjoy the comfort of tall ceilings, built-in bookcases, and cozy fireplaces in select homes. With convenient online resident services and a beautiful courtyard gazebo, you'll love calling Mcalister home. Picture yourself living here!",
  "property_seo_title_virtualtours": "Virtual Tours | Mcalister Apartments",
  "property_seo_description_virtualtours": "Discover your new home at Mcalister in Webster, TX! Explore our spacious one and two-bedroom floor plans and take a virtual tour of our vibrant community. Experience modern living at its best—click now to envision your future!",
  "property_seo_title_interactivemap": "Interactive Map | Mcalister Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Mcalister in Webster, TX! Choose from spacious one and two-bedroom floor plans with luxurious amenities, including a sparkling pool, modern fitness center, and serene outdoor spaces. Enjoy features like high ceilings, built-in bookcases, and full-size washer & dryer connections. Use our interactive community map to explore available apartments, check pricing, and find your ideal living space today! Experience elevated living at Mcalister.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Webster, TX",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Mcalister in Webster, TX! Explore our one and two-bedroom apartment floor plans and see what local favorites and nearby points of interest await you. Dive into the community and find your perfect home—start exploring today!",
  "property_seo_title_contact": "Contact Us | Mcalister",
  "property_seo_description_contact": "Discover your new home at Mcalister in Webster, TX! Explore our thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Have questions? Our leasing team is here to help—contact us today!",
  "property_seo_title_faqs": "FAQs | Apartments in Webster, TX",
  "property_seo_description_faqs": "Discover all you need to know about McAlister in Webster, TX! From spacious one and two-bedroom floor plans to top-notch amenities like a fitness center, pool, and included washer & dryer, we’ve got it all. Explore features such as covered parking, double vanities, and charming outdoor spaces. Have questions? Browse our FAQs page for helpful answers about our vibrant community and its offerings. Your ideal apartment lifestyle awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Webster, TX",
  "property_seo_description_reviews": "Discover the charm of McAlister, located in vibrant Webster, TX! Explore our thoughtfully designed one and two-bedroom floor plans, featuring modern amenities like a fitness center, pool, and covered parking. Enjoy spacious living with tall ceilings, cozy fireplaces, and beautiful gazebos. Experience hassle-free living with online resident services and a convenient package system. Curious about life at McAlister? See what our residents have to say about their experiences in our welcoming community!",
  "property_seo_title_applynow": "Apply Now | Apartments in Webster, TX",
  "property_seo_description_applynow": "Discover your ideal living space at Mcalister in Webster, TX! Explore our diverse floor plans, featuring stylish one and two-bedroom apartments with amenities like a fitness center, pool, and outdoor gazebo. Enjoy chic interiors boasting tall ceilings, built-in bookcases, and spacious laundry rooms. With covered parking and convenient online resident services, your comfort is our priority. Ready to elevate your lifestyle? Apply now and find your new home—lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Mcalister",
  "property_seo_description_residentaccess": "\"Welcome to Mcalister in Webster, TX! Access your resident portal today to easily pay rent, schedule maintenance, and manage your apartment needs all in one place. Experience convenience at your fingertips!\"",
  "property_seo_title_referafriend": "Refer A Friend | Mcalister",
  "property_seo_description_referafriend": "\"Share the joy of living at Mcalister in Webster, TX! Refer a friend to our vibrant apartment community today and enjoy great perks together. Great friends make great neighbors—let's build a wonderful community together!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Mcalister",
  "property_seo_description_scheduletour": "\"Explore Mcalister Apartments in Webster, TX! Discover your dream home in our vibrant community. Schedule a tour today to experience luxury living, modern amenities, and a welcoming atmosphere. Don’t miss out – book your tour now!\"",
  "property_seo_title_privacy": "Privacy Policy | Mcalister",
  "property_seo_description_privacy": "Discover how Mcalister prioritizes your privacy in Webster, TX. Our privacy policy outlines our commitment to protecting your personal information. View our privacy policy today to learn more!",
  "property_seo_title_accessibility": "Website Accessibility | Mcalister",
  "property_seo_description_accessibility": "\"Discover Mcalister in Webster, TX, where we prioritize accessibility and digital inclusion for all residents. Explore our commitment to providing a welcoming and supportive environment. Join our community today!\"",
  "property_seo_title_sitemap": "Sitemap | Mcalister",
  "property_seo_description_sitemap": "Discover every corner of Mcalister, your ideal apartment community in Webster, TX. Explore our comprehensive sitemap to easily navigate our amenities, floor plans, and local attractions. Visit our website now to find your perfect home!",
  "property_seo_title_thankyou": "Thank You | Mcalister",
  "property_seo_description_thankyou": "Thank you for reaching out to Mcalister in Webster, TX! Your inquiry is important to us. A member of our dedicated team will be in touch shortly to assist you with your apartment search. Stay tuned for exciting updates on your future home!",
  "property_seo_title_pets": "Pet Policy | Apartments in Summerville, SC\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320001",
  "amenities": [
    {
      "id": "custom_407d16a9-d310-4aea-be06-e17563721e06",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_242d534d-fec0-4717-899d-a8e610283c3c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "external_id": "P000000603",
      "title": "Blinds",
      "amount": "0.0000",
      "description": "Two Inch Blinds",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0502f8cf-eb1c-4c3e-a749-27ed2ac55f1c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "external_id": "P000000604",
      "title": "Built-In Bookcase",
      "amount": "0.0000",
      "description": "Built-In Bookcases",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b3eedec7-2ce0-4db8-8dd8-dead263344ee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "external_id": "P000000623",
      "title": "Covered Parking",
      "amount": "0.0000",
      "description": "Reserved Covered Parking Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b4d37fb2-1ad4-4b9f-b5cd-70bc39ff678d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "external_id": "P000000629",
      "title": "Double Vanity",
      "amount": "0.0000",
      "description": "Double Bathroom Vanity*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6ff1681a-00be-4d8f-adf9-6bf69cc8fee4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "external_id": "P000000633",
      "title": "Fire",
      "amount": "0.0000",
      "description": "Wood Burning Fireplaces*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ee501297-4f90-4c93-982c-501c5a3dfec5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern Fitness Center with Cardio Studio",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_64c1de4e-96c7-430c-8564-2684a3627914",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "external_id": "P000000637",
      "title": "French Doors",
      "amount": "0.0000",
      "description": "French Doors",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bded0d2a-710d-4063-adc4-2376caf1e31f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "external_id": "P000000642",
      "title": "Gazebo",
      "amount": "0.0000",
      "description": "Relaxing Community Gazebos",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8062062c-9e52-4524-926a-4613263b4736",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8a7c11fd-11e4-485d-b2a4-29d05d3e6923",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_83f5014f-9c1d-4dd6-b64a-7a95e9e13ebe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "external_id": "P000000656",
      "title": "Laundry Rooms",
      "amount": "0.0000",
      "description": "24-Hour Onsite Resident Laundry Care Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f7c1e904-405f-4b5e-ae90-da92d99d19dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d94af2a2-ac11-43be-8d6b-c63063441434",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_af224c74-a032-430b-b365-f1d3b322f277",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "external_id": "P000000665",
      "title": "Package System",
      "amount": "0.0000",
      "description": "24-Hour Resident Package System**",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e7a7051d-7e9a-4de5-9b55-4c0afadb47a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Swimming Pool with Heated Spa",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bb3f6486-8175-4224-acdb-70d998b03dbf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7b9b96f7-628c-47a2-89d3-97450ce86d31",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "Vaulted Ceilings*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fab4d73b-853e-41e3-bf7d-6e016c7b9c46",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "external_id": "P000000698",
      "title": "USB Outlet",
      "amount": "0.0000",
      "description": "Wall Outlets with USB Ports*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ee6ebb34-c335-481d-a343-eaed2591997c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "external_id": "P000000703",
      "title": "W&D Connections",
      "amount": "0.0000",
      "description": "Washer & Dryer*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_ab35b2fe-58b9-4df3-85a4-147e6c28f367",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-d691-7701-9f2e-9ddd94952dc9.webp",
      "image_media": {
        "alt_text": "Gazebo and barbecue grill area on a green lawn with apartment buildings in the background.",
        "public_id": "019e89a1-d691-7701-9f2e-9ddd94952dc9",
        "storage_key": "property/5682633027616768/019e89a1-d691-7701-9f2e-9ddd94952dc9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings in our community's shaded gazebo and barbecue area, surrounded by lush landscaping and apartment buildings.",
      "link": "",
      "alt_text": "Gazebo and barbecue grill area on a green lawn with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bc0fab54-be04-412d-9a5f-80cbb3383307",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-d9a4-73af-a37e-3b2f7514f629.webp",
      "image_media": {
        "alt_text": "Coffee and water station with seating area in apartment complex lounge.",
        "public_id": "019e89a1-d9a4-73af-a37e-3b2f7514f629",
        "storage_key": "property/5682633027616768/019e89a1-d9a4-73af-a37e-3b2f7514f629.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and refreshments at our community lounge's beverage station, a perfect spot to relax or catch up.",
      "link": "",
      "alt_text": "Coffee and water station with seating area in apartment complex lounge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3632ef88-bf92-4764-8d69-0dd544c0e008",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-d5ce-727b-8d8e-c57412b20536.webp",
      "image_media": {
        "alt_text": "Gazebo with picnic tables and a grill in a grassy courtyard with apartment buildings in the background.",
        "public_id": "019e89a1-d5ce-727b-8d8e-c57412b20536",
        "storage_key": "property/5682633027616768/019e89a1-d5ce-727b-8d8e-c57412b20536.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and relaxation in our community gazebo, complete with picnic tables and a barbecue grill. A perfect spot for gatherings or a quiet meal surrounded by our beautiful grounds.",
      "link": "",
      "alt_text": "Gazebo with picnic tables and a grill in a grassy courtyard with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c7e7fce4-855b-4487-bdac-f59a2e9ad97f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-cc2b-7271-8bd4-2747e075b58c.webp",
      "image_media": {
        "alt_text": "Exercise bikes and a large TV in the gym.",
        "public_id": "019e89a1-cc2b-7271-8bd4-2747e075b58c",
        "storage_key": "property/5682633027616768/019e89a1-cc2b-7271-8bd4-2747e075b58c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines and more.",
      "link": "",
      "alt_text": "Exercise bikes and a large TV in the gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_04488cf6-0ed3-4af1-b0b6-5d44d6dff4f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-d117-70fc-9517-9b278b0de5de.webp",
      "image_media": {
        "alt_text": "Modern living room with a large black sectional sofa, decorative pillows, and a glass coffee table.",
        "public_id": "019e89a1-d117-70fc-9517-9b278b0de5de",
        "storage_key": "property/5682633027616768/019e89a1-d117-70fc-9517-9b278b0de5de.webp",
        "width": 3072,
        "height": 2040
      },
      "title": "Apartment",
      "description": "Relax in the spacious and elegantly furnished living room, perfect for unwinding or entertaining guests.",
      "link": "",
      "alt_text": "Modern living room with a large black sectional sofa, decorative pillows, and a glass coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c80487d1-fe91-4222-a635-273a0beac4cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-c821-7683-8ea3-e46083b4e5cd.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019e89a1-c821-7683-8ea3-e46083b4e5cd",
        "storage_key": "property/5682633027616768/019e89a1-c821-7683-8ea3-e46083b4e5cd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling pool, perfect for relaxing and soaking up the sun. Surrounded by comfortable lounge chairs and shaded umbrellas, it's the ideal spot to unwind.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e57e3ef5-6571-4745-97ac-752a83f172c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-c547-7239-b170-76ec2cf28042.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and walkways.",
        "public_id": "019e89a1-c547-7239-b170-76ec2cf28042",
        "storage_key": "property/5682633027616768/019e89a1-c547-7239-b170-76ec2cf28042.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of brick and siding apartment buildings with well-maintained lawns and walkways, showcasing the property's architecture and grounds.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with manicured lawns and walkways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_76f13f4a-85e9-4c63-9d08-3d22baf5a17e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-c81f-75a8-94bd-4b5cb1163db5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019e89a1-c81f-75a8-94bd-4b5cb1163db5",
        "storage_key": "property/5682633027616768/019e89a1-c81f-75a8-94bd-4b5cb1163db5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring stainless steel appliances, ample cabinet space, and elegant granite countertops, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9b07482d-0f66-4c32-a888-713cea0fda59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-c43a-70fe-9929-3c993e42c9bc.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, and dining area with kitchen in background.",
        "public_id": "019e89a1-c43a-70fe-9929-3c993e42c9bc",
        "storage_key": "property/5682633027616768/019e89a1-c43a-70fe-9929-3c993e42c9bc.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living area featuring a plush sofa, modern coffee table, and a separate dining space with a view into the updated kitchen.",
      "link": "",
      "alt_text": "Living room with sofa, coffee table, and dining area with kitchen in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8973305a-4733-4b44-b130-14de6a6905df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-bebe-7012-b58a-ea218feb7779.webp",
      "image_media": {
        "alt_text": "Gym with cardio machines and weight training equipment",
        "public_id": "019e89a1-bebe-7012-b58a-ea218feb7779",
        "storage_key": "property/5682633027616768/019e89a1-bebe-7012-b58a-ea218feb7779.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of cardio and strength training equipment for residents.",
      "link": "",
      "alt_text": "Gym with cardio machines and weight training equipment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5b34732b-4fc3-4eda-a921-dc72410e67b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-c0ff-7648-a60b-fe7965187fe7.webp",
      "image_media": {
        "alt_text": "Luxer One package lockers with a digital screen and keypad.",
        "public_id": "019e89a1-c0ff-7648-a60b-fe7965187fe7",
        "storage_key": "property/5682633027616768/019e89a1-c0ff-7648-a60b-fe7965187fe7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Secure and convenient package lockers for residents, managed by Luxer One. Features a digital screen and keypad for easy access.",
      "link": "",
      "alt_text": "Luxer One package lockers with a digital screen and keypad.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e5157aad-7fa7-47c5-8474-ad48e967a07a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-b821-728b-8e4d-09d8094f6dbf.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e89a1-b821-728b-8e4d-09d8094f6dbf",
        "storage_key": "property/5682633027616768/019e89a1-b821-728b-8e4d-09d8094f6dbf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by lush palm trees and comfortable lounge seating.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bfc15b12-6ee8-4efd-801f-defe0a3daa09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-b809-7553-bf3e-49647abd416d.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and weight machines.",
        "public_id": "019e89a1-b809-7553-bf3e-49647abd416d",
        "storage_key": "property/5682633027616768/019e89a1-b809-7553-bf3e-49647abd416d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring state-of-the-art cardio and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6c6a2de0-1e13-4a5a-9664-f8a775a84481",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-b5e2-762b-bcae-bca8c3f6a28a.webp",
      "image_media": {
        "alt_text": "Living room and dining area with a TV, coffee table, and dining set.",
        "public_id": "019e89a1-b5e2-762b-bcae-bca8c3f6a28a",
        "storage_key": "property/5682633027616768/019e89a1-b5e2-762b-bcae-bca8c3f6a28a.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "A spacious living and dining area featuring a modern TV console, a stylish coffee table, and a comfortable dining set, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and dining area with a TV, coffee table, and dining set.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8aec6aff-f8d6-4f21-a9fb-0b0aa5e163c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-a71c-72c4-a109-567661344557.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with green lawns and trees.",
        "public_id": "019e89a1-a71c-72c4-a109-567661344557",
        "storage_key": "property/5682633027616768/019e89a1-a71c-72c4-a109-567661344557.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds with apartment buildings featuring brick and siding exteriors.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with green lawns and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a1197441-d33b-4ae4-b448-6a4407000745",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-a63d-7443-99ca-4ee749085981.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019e89a1-a63d-7443-99ca-4ee749085981",
        "storage_key": "property/5682633027616768/019e89a1-a63d-7443-99ca-4ee749085981.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6c71ab47-985a-43ac-ae02-a6a2a90c170a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-a6ee-773a-9729-631712817e37.webp",
      "image_media": {
        "alt_text": "Living and dining area with TV, dining table, and kitchen in the background.",
        "public_id": "019e89a1-a6ee-773a-9729-631712817e37",
        "storage_key": "property/5682633027616768/019e89a1-a6ee-773a-9729-631712817e37.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish living and dining area featuring a wall-mounted TV, a modern dining set, and a glimpse of the updated kitchen.",
      "link": "",
      "alt_text": "Living and dining area with TV, dining table, and kitchen in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ddd4c8db-f61f-4897-b6a6-34f011246745",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-9f3e-76a9-89e1-5fa74f7039de.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
        "public_id": "019e89a1-9f3e-76a9-89e1-5fa74f7039de",
        "storage_key": "property/5682633027616768/019e89a1-9f3e-76a9-89e1-5fa74f7039de.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by our sparkling swimming pool, complete with comfortable lounge chairs and shaded umbrellas. Perfect for a sunny afternoon.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_11c655d6-610a-43b8-b6b4-0c78406b651e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-9e65-75e8-b218-a8b634102d91.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines and cardio equipment.",
        "public_id": "019e89a1-9e65-75e8-b218-a8b634102d91",
        "storage_key": "property/5682633027616768/019e89a1-9e65-75e8-b218-a8b634102d91.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with a variety of weight and cardio machines to suit all your workout needs.",
      "link": "",
      "alt_text": "Fitness center with weight machines and cardio equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f866ca13-6726-4646-a190-a229fee2a58a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-a239-717d-bfc8-cfb546471262.webp",
      "image_media": {
        "alt_text": "Dining area and living room with TV in apartment.",
        "public_id": "019e89a1-a239-717d-bfc8-cfb546471262",
        "storage_key": "property/5682633027616768/019e89a1-a239-717d-bfc8-cfb546471262.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy a stylish dining area adjacent to the living room, complete with a large TV and elegant decor. Perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Dining area and living room with TV in apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_117106c6-e421-41a0-b1a5-b45812859d68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-95a3-755a-aa3a-44b5bbfb08b4.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and palm trees in front of apartment buildings.",
        "public_id": "019e89a1-95a3-755a-aa3a-44b5bbfb08b4",
        "storage_key": "property/5682633027616768/019e89a1-95a3-755a-aa3a-44b5bbfb08b4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in the sparkling pool, surrounded by lush landscaping and comfortable lounge chairs.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and palm trees in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_15ad9507-3856-4688-ab6b-f88de260d094",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-90a6-76a8-88c3-f6140c1cb483.webp",
      "image_media": {
        "alt_text": "Living room with a gray sofa, coffee table, and TV.",
        "public_id": "019e89a1-90a6-76a8-88c3-f6140c1cb483",
        "storage_key": "property/5682633027616768/019e89a1-90a6-76a8-88c3-f6140c1cb483.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Spacious and modern living room featuring a comfortable gray sofa, a stylish coffee table, and a large TV. The room is adorned with abstract art and a vibrant rug, creating a welcoming atmosphere.",
      "link": "",
      "alt_text": "Living room with a gray sofa, coffee table, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_60c8caa5-06c5-4534-9372-d97b6ddd9e3b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-9135-773d-9039-8a116744afc0.webp",
      "image_media": {
        "alt_text": "Covered patio area with blue outdoor seating and coffee table.",
        "public_id": "019e89a1-9135-773d-9039-8a116744afc0",
        "storage_key": "property/5682633027616768/019e89a1-9135-773d-9039-8a116744afc0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind on the stylish covered patio, complete with comfortable seating and a modern coffee table.",
      "link": "",
      "alt_text": "Covered patio area with blue outdoor seating and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_05a6c65e-30b9-49b1-b6e8-85543346d4a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-962f-77ee-9732-aab3636fb8ed.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019e89a1-962f-77ee-9732-aab3636fb8ed",
        "storage_key": "property/5682633027616768/019e89a1-962f-77ee-9732-aab3636fb8ed.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, featuring comfortable lounge chairs and shaded umbrellas. Enjoy the resort-style amenities at our community.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_92e5aefc-c643-46d1-8c13-128a5c24f4dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-8575-70ae-8c8e-5f98a595966b.webp",
      "image_media": {
        "alt_text": "Modern kitchen area with a breakfast bar and stools, opening into a stylish living space with abstract art.",
        "public_id": "019e89a1-8575-70ae-8c8e-5f98a595966b",
        "storage_key": "property/5682633027616768/019e89a1-8575-70ae-8c8e-5f98a595966b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy this beautifully designed space, featuring a contemporary kitchen with a breakfast bar and elegant seating, perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Modern kitchen area with a breakfast bar and stools, opening into a stylish living space with abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_041b0427-ff94-4a2e-b849-25375ab032a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-8391-75e8-947b-3af0fe4b6d48.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and abstract art.",
        "public_id": "019e89a1-8391-75e8-947b-3af0fe4b6d48",
        "storage_key": "property/5682633027616768/019e89a1-8391-75e8-947b-3af0fe4b6d48.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed living room, featuring a plush sofa, stylish coffee table, and vibrant abstract art.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee table, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_09fa953c-fe17-4449-8b8c-b5eca03249b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-87b1-718e-aada-d1c40bbe4271.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-sized bed, navy blue accent wall, and modern ceiling fan.",
        "public_id": "019e89a1-87b1-718e-aada-d1c40bbe4271",
        "storage_key": "property/5682633027616768/019e89a1-87b1-718e-aada-d1c40bbe4271.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a plush queen bed, a stylish navy accent wall, and a modern ceiling fan for ultimate comfort. Perfect for a restful night's sleep.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-sized bed, navy blue accent wall, and modern ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ff88e31b-50e1-4eb5-ae0e-4ee2adb5b304",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-83c6-70ac-849a-44595b7cfddb.webp",
      "image_media": {
        "alt_text": "Lounge area with a large sectional sofa, coffee table, and dining area visible through an opening.",
        "public_id": "019e89a1-83c6-70ac-849a-44595b7cfddb",
        "storage_key": "property/5682633027616768/019e89a1-83c6-70ac-849a-44595b7cfddb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax in our stylish lounge area, perfect for unwinding or entertaining. Enjoy the comfortable seating and sophisticated decor.",
      "link": "",
      "alt_text": "Lounge area with a large sectional sofa, coffee table, and dining area visible through an opening.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_50738436-a6b3-4078-972f-1af5e8943414",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e89a1-8471-7339-9fb5-4880faad9d89.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and bathtub with a shower curtain.",
        "public_id": "019e89a1-8471-7339-9fb5-4880faad9d89",
        "storage_key": "property/5682633027616768/019e89a1-8471-7339-9fb5-4880faad9d89.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "View of a contemporary bathroom featuring a white vanity with a sink and silver faucet, a toilet, and a bathtub with a stylish shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, and bathtub with a shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_822878c262d8a649fd4af63c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "155 El Dorado Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-b0bf-726d-94c6-0ccd4c832a67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-b0bf-726d-94c6-0ccd4c832a67",
        "storage_key": "property/5682633027616768/019f1503-b0bf-726d-94c6-0ccd4c832a67.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/tx/webster/155-el-dorado-blvd?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=204120&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=9678838280945985531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "29.5558505",
      "poi_longitude": "-95.1513481",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-286-3273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-1fde-703d-8fc4-73e793c52c8b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-1fde-703d-8fc4-73e793c52c8b",
        "storage_key": "property/5682633027616768/019f1504-1fde-703d-8fc4-73e793c52c8b.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJC48pQIObQIYR--c8xiIkUoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_9752634e0afc928e2c9c2771",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Cafe Dew",
      "poi_type": "Restaurants",
      "poi_address": "105 W Bay Area Blvd, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-b235-74c8-9424-8c7c9547e69e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-b235-74c8-9424-8c7c9547e69e",
        "storage_key": "property/5682633027616768/019f1503-b235-74c8-9424-8c7c9547e69e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://thecafedew.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14073788912536537216&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cafe-dew",
      "poi_latitude": "29.5480346",
      "poi_longitude": "-95.1289026",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-525-4541",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-1fde-703d-8fc4-73e793c52c8b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-1fde-703d-8fc4-73e793c52c8b",
        "storage_key": "property/5682633027616768/019f1504-1fde-703d-8fc4-73e793c52c8b.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJlzZzSgKdQIYRgEiSJ3MkUMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_dd680cb409ef3425bf4811b2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "122 El Dorado Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1500-eb4c-734c-95d7-0820dea57465.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-eb4c-734c-95d7-0820dea57465",
        "storage_key": "property/5682633027616768/019f1500-eb4c-734c-95d7-0820dea57465.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.in-n-out.com/397",
      "poi_directions_map_url": "https://maps.google.com/?cid=8917601343789676553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "29.553425",
      "poi_longitude": "-95.1503191",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b7-7410-93d1-0684a7c87e9e",
        "storage_key": "property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLbbt00-bQIYRCTghuSyvwXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_051507fbb95dc32494a4e39f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "The Taco Stand",
      "poi_type": "Restaurants",
      "poi_address": "118 El Dorado Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Lively taco joint doling out a variety of Mexican staples such as burritos and bowls, with tortillas made in-house.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-b6d4-710b-8171-cbc6962adc64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-b6d4-710b-8171-cbc6962adc64",
        "storage_key": "property/5682633027616768/019f1503-b6d4-710b-8171-cbc6962adc64.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://tacostandhtx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2225665112799213382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-taco-stand",
      "poi_latitude": "29.5537948",
      "poi_longitude": "-95.1506242",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-954-6134",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b7-7410-93d1-0684a7c87e9e",
        "storage_key": "property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJj9C4UQCbQIYRRndgxaAm4x4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "ec_05e4b691820a80dc3473c60f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Taqueria El Pavo Real",
      "poi_type": "Restaurants",
      "poi_address": "435 El Dorado Blvd #8, Webster, TX 77598, USA",
      "poi_short_description": "Casual eatery featuring Mexican tacos, fajitas and other classics, including catering services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-b1be-701f-9184-b3203cedc6df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-b1be-701f-9184-b3203cedc6df",
        "storage_key": "property/5682633027616768/019f1503-b1be-701f-9184-b3203cedc6df.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13881034004157319357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taqueria-el-pavo-real",
      "poi_latitude": "29.5587865",
      "poi_longitude": "-95.1463426",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 832-762-1246",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b7-7410-93d1-0684a7c87e9e",
        "storage_key": "property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK86ED7qbQIYRvUjqxOFWo8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_f17a1ef81bb4d100846100ff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "JB's Chinese Cafe",
      "poi_type": "Restaurants",
      "poi_address": "576 El Dorado Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Chinese basics from egg rolls to shrimp with broccoli fill out the menu at this strip-mall eatery.",
      "poi_long_description": "Chinese basics from egg rolls to shrimp with broccoli fill out the menu at this strip-mall eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-b0ca-74af-b868-1f7df178913f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-b0ca-74af-b868-1f7df178913f",
        "storage_key": "property/5682633027616768/019f1503-b0ca-74af-b868-1f7df178913f.webp",
        "width": 1280,
        "height": 1105
      },
      "poi_business_url": "http://www.jbscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2680561317975521136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jbs-chinese-cafe",
      "poi_latitude": "29.5606131",
      "poi_longitude": "-95.14023",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 281-461-1888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b7-7410-93d1-0684a7c87e9e",
        "storage_key": "property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJabTDPnicQIYRcHeVBFFEMyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_f98e5acd4c941a7799df6793",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "304 W Bay Area Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-b1c7-770a-b10d-7404cdd7fbc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-b1c7-770a-b10d-7404cdd7fbc8",
        "storage_key": "property/5682633027616768/019f1503-b1c7-770a-b10d-7404cdd7fbc8.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://locations.chipotle.com/tx/webster/304-w-bay-area-blvd?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=1185",
      "poi_directions_map_url": "https://maps.google.com/?cid=13898459250482570786&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "29.5476802",
      "poi_longitude": "-95.1313626",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-332-6597",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b7-7410-93d1-0684a7c87e9e",
        "storage_key": "property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOQNA-4icQIYRImZBFg0_4cA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_6a9cb9b3cc47e6e7319c4df9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Carrabba's Italian Grill",
      "poi_type": "Restaurants",
      "poi_address": "502 W Bay Area Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Chain eatery & bar serving a diverse menu of classic Italian fare in a family-friendly setting.",
      "poi_long_description": "Chain eatery & bar serving a diverse menu of classic Italian fare in a family-friendly setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-b61f-76b2-bf5a-ad80b04b0709.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-b61f-76b2-bf5a-ad80b04b0709",
        "storage_key": "property/5682633027616768/019f1503-b61f-76b2-bf5a-ad80b04b0709.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://locations.carrabbas.com/texas/webster/502-west-bay-area-blvd?y_source=1_MTU1MDMwMTAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12875568657407862797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrabbas-italian-grill",
      "poi_latitude": "29.5461244",
      "poi_longitude": "-95.1333358",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-338-0574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b7-7410-93d1-0684a7c87e9e",
        "storage_key": "property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV1xaF4acQIYRDejy6Xk1r7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_7b9e9c5b0a98afc454f38519",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "BJ's Restaurant & Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "515 W Bay Area Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_long_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-b743-70bf-87cd-8a501a621868.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-b743-70bf-87cd-8a501a621868",
        "storage_key": "property/5682633027616768/019f1503-b743-70bf-87cd-8a501a621868.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bjsrestaurants.com/locations/tx/clear-lake?utm_source=google&utm_medium=organic&utm_campaign=google_my_business",
      "poi_directions_map_url": "https://maps.google.com/?cid=9858660027509089830&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bjs-restaurant--brewhouse",
      "poi_latitude": "29.5452339",
      "poi_longitude": "-95.1324738",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-316-3037",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b7-7410-93d1-0684a7c87e9e",
        "storage_key": "property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhQ-pAYacQIYRJqYFxQ__0Ig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_f98146e3159a795833bf2e05",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Five Guys",
      "poi_type": "Restaurants",
      "poi_address": "1333 W Bay Area Blvd #300, Webster, TX 77598, USA",
      "poi_short_description": "Fast-food chain with made-to-order burgers, fries & hot dogs, plus free peanuts while you wait.",
      "poi_long_description": "Fast-food chain with made-to-order burgers, fries & hot dogs, plus free peanuts while you wait.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-b558-7637-8b7e-38bd837401af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-b558-7637-8b7e-38bd837401af",
        "storage_key": "property/5682633027616768/019f1503-b558-7637-8b7e-38bd837401af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://restaurants.fiveguys.com/1333-w-bay-area-blvd",
      "poi_directions_map_url": "https://maps.google.com/?cid=2775904437373840661&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-guys",
      "poi_latitude": "29.5387473",
      "poi_longitude": "-95.1437869",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-332-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b7-7410-93d1-0684a7c87e9e",
        "storage_key": "property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJffK98oicQIYRFS0Z4GD-hSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_81de8465d6421767b3c95ec5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Kura Revolving Sushi Bar",
      "poi_type": "Restaurants",
      "poi_address": "1065 W Bay Area Blvd Ste 230, Webster, TX 77598, USA",
      "poi_short_description": "Buzzy eatery serving sushi, udon noodles and tempura dishes, all delivered via conveyor belt.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-b548-7792-9a6d-3eea01929122.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-b548-7792-9a6d-3eea01929122",
        "storage_key": "property/5682633027616768/019f1503-b548-7792-9a6d-3eea01929122.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kurasushi.com/locations/webster-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=17885117612067389481&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kura-revolving-sushi-bar",
      "poi_latitude": "29.5403838",
      "poi_longitude": "-95.1399294",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-944-7878",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b7-7410-93d1-0684a7c87e9e",
        "storage_key": "property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSY4EEgCdQIYRKQBccbWzNPg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "ec_af33a5e09ce55777e029dbb5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Torchy's Tacos",
      "poi_type": "Restaurants",
      "poi_address": "19431 Gatebrook Dr, Webster, TX 77598, USA",
      "poi_short_description": "Buzzy chain serving Mexican street-food-style tacos in inventive varieties, including for breakfast.",
      "poi_long_description": "Buzzy chain serving Mexican street-food-style tacos in inventive varieties, including for breakfast.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-c030-7787-aa96-a14315109301.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-c030-7787-aa96-a14315109301",
        "storage_key": "property/5682633027616768/019f1503-c030-7787-aa96-a14315109301.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://torchystacos.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=14837897111589031481&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "torchys-tacos",
      "poi_latitude": "29.5431172",
      "poi_longitude": "-95.1382206",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-724-3508",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b7-7410-93d1-0684a7c87e9e",
        "storage_key": "property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXXxViIOcQIYROQ4P9s7M6s0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_071689c0711be89c6eb983f6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Shake Shack Baybrook",
      "poi_type": "Restaurants",
      "poi_address": "19677 Gulf Fwy, Webster, TX 77598, USA",
      "poi_short_description": "Hip, counter-serve chain for gourmet takes on fast-food classics like burgers & frozen custard.",
      "poi_long_description": "Hip, counter-serve chain for gourmet takes on fast-food classics like burgers & frozen custard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-bcaf-72a6-a599-73b290dcf2d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-bcaf-72a6-a599-73b290dcf2d1",
        "storage_key": "property/5682633027616768/019f1503-bcaf-72a6-a599-73b290dcf2d1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://shakeshack.com/location/Baybrook-TX?utm_source=google&utm_medium=listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=10671514651770372770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shake-shack-baybrook",
      "poi_latitude": "29.5397833",
      "poi_longitude": "-95.1395668",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 346-712-2132",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b7-7410-93d1-0684a7c87e9e",
        "storage_key": "property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRz2z_iGdQIYRokImIgnWGJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_8e78994a9bd4c195af28b5b5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "1450 W Bay Area Blvd, Friendswood, TX 77546, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-bcc4-7068-98da-53fb1cec5770.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-bcc4-7068-98da-53fb1cec5770",
        "storage_key": "property/5682633027616768/019f1503-bcc4-7068-98da-53fb1cec5770.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/tx/friendswood-162.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=4974652028511353285&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "29.5390788",
      "poi_longitude": "-95.1465869",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-488-0822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b7-7410-93d1-0684a7c87e9e",
        "storage_key": "property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT-bZKmObQIYRxXmYwKmDCUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_2883cb4193297e7f60f9319d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Lupe Tortilla Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "891 W Bay Area Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Regional Tex-Mex chain known for its homemade tortillas & variety of margaritas.",
      "poi_long_description": "Regional Tex-Mex chain known for its homemade tortillas & variety of margaritas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-bcc5-767e-9c2a-494819208218.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-bcc5-767e-9c2a-494819208218",
        "storage_key": "property/5682633027616768/019f1503-bcc5-767e-9c2a-494819208218.webp",
        "width": 1280,
        "height": 810
      },
      "poi_business_url": "https://tex-mex.com/clear-lake/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9704068999364285982&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lupe-tortilla-mexican-restaurant",
      "poi_latitude": "29.5418018",
      "poi_longitude": "-95.1355139",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-338-2711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b7-7410-93d1-0684a7c87e9e",
        "storage_key": "property/5682633027616768/019f1501-44b7-7410-93d1-0684a7c87e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbzMHZ4ScQIYRHhb9LlfHq4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_8f2b1921bec418b6d7214855",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Sara's Food Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "435 El Dorado Blvd Ste 14, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17482694670347597338&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saras-food-mart",
      "poi_latitude": "29.5589222",
      "poi_longitude": "-95.145982",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-1fe1-741a-8e14-fef426f05cac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-1fe1-741a-8e14-fef426f05cac",
        "storage_key": "property/5682633027616768/019f1504-1fe1-741a-8e14-fef426f05cac.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJN05h_oabQIYRGvau5iwCn_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_625b13adb8c21228e236196d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "El Dorado Food Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "501 El Dorado Blvd #B, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1584350416633976942&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-dorado-food-mart",
      "poi_latitude": "29.5593969",
      "poi_longitude": "-95.1455372",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 281-286-7996",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-1fe1-741a-8e14-fef426f05cac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-1fe1-741a-8e14-fef426f05cac",
        "storage_key": "property/5682633027616768/019f1504-1fe1-741a-8e14-fef426f05cac.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJIRU-poebQIYRbtg1R0--_BU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_dd6f2b2410a382c8523a48a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "550 El Dorado Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-c1d7-7569-8da2-c3f76007bcd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-c1d7-7569-8da2-c3f76007bcd4",
        "storage_key": "property/5682633027616768/019f1503-c1d7-7569-8da2-c3f76007bcd4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.familydollar.com/tx/webster/550-el-dorado-blvd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=16232284430924176713&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "29.5596134",
      "poi_longitude": "-95.1415235",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 346-474-0321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44ca-77cf-8a0b-8a3f09e07c59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44ca-77cf-8a0b-8a3f09e07c59",
        "storage_key": "property/5682633027616768/019f1501-44ca-77cf-8a0b-8a3f09e07c59.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5yc0cXicQIYRSd1WBrCoROE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_04ea0366399228b8c52cc5bd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "El Dorado Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "570 El Dorado Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Shopping center featuring a supermarket, a gym, and a fast food spot, plus a place for eyebrow and lash services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-c281-722c-8cc8-ee05a85a2356.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-c281-722c-8cc8-ee05a85a2356",
        "storage_key": "property/5682633027616768/019f1503-c281-722c-8cc8-ee05a85a2356.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.commercialmg.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=621826975698590331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-dorado-shopping-center",
      "poi_latitude": "29.5597915",
      "poi_longitude": "-95.1410675",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 832-735-6114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-4511-776c-ae37-7dad29859a46",
        "storage_key": "property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh8TXsnmcQIYRexpF_lYsoQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "ec_046db4fd3ec7cca6fa36e05e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "18611 Eastfield Dr, Webster, TX 77598, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1500-e811-74cb-9075-31b7109f35f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-e811-74cb-9075-31b7109f35f7",
        "storage_key": "property/5682633027616768/019f1500-e811-74cb-9075-31b7109f35f7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/webster/el-dorado-h-e-b-769?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=5688881366909029&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "29.551901",
      "poi_longitude": "-95.1487218",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-488-1601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-4510-77e4-bc0a-f77f9b326e91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-4510-77e4-bc0a-f77f9b326e91",
        "storage_key": "property/5682633027616768/019f1501-4510-77e4-bc0a-f77f9b326e91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTa3bqtCbQIYRZUAL6QE2FAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_98d32a7740c281bb8e7f0b80",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "1310 Jasmine Ave, Webster, TX 77598, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-c1cd-72c2-a805-a8c79ed0cf2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-c1cd-72c2-a805-a8c79ed0cf2f",
        "storage_key": "property/5682633027616768/019f1503-c1cd-72c2-a805-a8c79ed0cf2f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/webster-TX-1330.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=3639438621570004531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "29.5337935",
      "poi_longitude": "-95.1394705",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-707-7750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44ca-77cf-8a0b-8a3f09e07c59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44ca-77cf-8a0b-8a3f09e07c59",
        "storage_key": "property/5682633027616768/019f1501-44ca-77cf-8a0b-8a3f09e07c59.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHyMAvUidQIYRM3aEzCTigTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "ec_0667af453bc76f1d2805140c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Pyramids Pharmacy Webster",
      "poi_type": "Shopping & Retail",
      "poi_address": "500 N Kobayashi Rd Suite D/E, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-c224-76aa-99c4-20c8aca9ff04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-c224-76aa-99c4-20c8aca9ff04",
        "storage_key": "property/5682633027616768/019f1503-c224-76aa-99c4-20c8aca9ff04.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pyramidspharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16910410147644675739&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pyramids-pharmacy-webster",
      "poi_latitude": "29.5341262",
      "poi_longitude": "-95.1297293",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 832-284-4933",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-1fe7-7099-9915-13d6839c41d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-1fe7-7099-9915-13d6839c41d8",
        "storage_key": "property/5682633027616768/019f1504-1fe7-7099-9915-13d6839c41d8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1UwwLJGcQIYRm5aFIG_Yreo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_d78cd2f9944260c21be73858",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1801 W Bay Area Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-c704-7288-8617-29a8645bd2ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-c704-7288-8617-29a8645bd2ab",
        "storage_key": "property/5682633027616768/019f1503-c704-7288-8617-29a8645bd2ab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/baybrook/1837",
      "poi_directions_map_url": "https://maps.google.com/?cid=11130154673306662091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "29.5360544",
      "poi_longitude": "-95.151189",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-819-4116",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44ca-77cf-8a0b-8a3f09e07c59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44ca-77cf-8a0b-8a3f09e07c59",
        "storage_key": "property/5682633027616768/019f1501-44ca-77cf-8a0b-8a3f09e07c59.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJCxxUBGWbQIYRy_SYjbRAdpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_bd878bef5a4e302532bfee00",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Baybrook Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "500 Baybrook Mall, Friendswood, TX 77546, USA",
      "poi_short_description": "Casual shopping plaza with stores for apparel, footwear, jewelry, home goods & kids, plus dining.",
      "poi_long_description": "Casual shopping plaza with stores for apparel, footwear, jewelry, home goods & kids, plus dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1500-e7a2-73b6-af65-9436dbaead1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-e7a2-73b6-af65-9436dbaead1d",
        "storage_key": "property/5682633027616768/019f1500-e7a2-73b6-af65-9436dbaead1d.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://www.baybrookmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3962758813461213470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baybrook-mall",
      "poi_latitude": "29.5427508",
      "poi_longitude": "-95.148508",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-667-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44ca-77cf-8a0b-8a3f09e07c59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44ca-77cf-8a0b-8a3f09e07c59",
        "storage_key": "property/5682633027616768/019f1501-44ca-77cf-8a0b-8a3f09e07c59.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOf21c3qbQIYRHnHnLiWM_jY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_7d19cb4b11bc7b0a6ed97b83",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Mc Whirter Elementary School",
      "poi_type": "Education",
      "poi_address": "300 Pennsylvania Ave, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-c7c7-71e9-a4b9-27e32146d855.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-c7c7-71e9-a4b9-27e32146d855",
        "storage_key": "property/5682633027616768/019f1503-c7c7-71e9-a4b9-27e32146d855.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://mcwhirter.ccisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10835443945066177171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mc-whirter-elementary-school",
      "poi_latitude": "29.53429019999999",
      "poi_longitude": "-95.1211094",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-284-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-450f-75de-b32a-34a4be8ba08c",
        "storage_key": "property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCWRL9OucQIYRk6JTAdw6X5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_52292bdbd3479439893a7e9b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Whitcomb Elementary School",
      "poi_type": "Education",
      "poi_address": "900 Reseda Dr, Houston, TX 77062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-cdd3-7369-931e-e228ab18f881.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-cdd3-7369-931e-e228ab18f881",
        "storage_key": "property/5682633027616768/019f1503-cdd3-7369-931e-e228ab18f881.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://whitcomb.ccisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18226808327691630269&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whitcomb-elementary-school",
      "poi_latitude": "29.559797",
      "poi_longitude": "-95.129724",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-284-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-450f-75de-b32a-34a4be8ba08c",
        "storage_key": "property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqZGwpGWcQIYRvfYwsZqh8vw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_040d3f2c7373205c149a51de",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Clear View High School",
      "poi_type": "Education",
      "poi_address": "500 S Walnut St, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-c9fa-7094-87c3-b4c75ecac3d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-c9fa-7094-87c3-b4c75ecac3d6",
        "storage_key": "property/5682633027616768/019f1503-c9fa-7094-87c3-b4c75ecac3d6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://clearview.ccisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13458604954412165749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clear-view-high-school",
      "poi_latitude": "29.5320727",
      "poi_longitude": "-95.1208356",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-284-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-450f-75de-b32a-34a4be8ba08c",
        "storage_key": "property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeV6Y4uqcQIYRdaoMOOaRxro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_d425040b13b0a37ef03236c9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Clear Lake Intermediate School",
      "poi_type": "Education",
      "poi_address": "15545 El Camino Real, Houston, TX 77062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-c942-761f-9587-053e0649bc08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-c942-761f-9587-053e0649bc08",
        "storage_key": "property/5682633027616768/019f1503-c942-761f-9587-053e0649bc08.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://clearlakeint.ccisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12853564226731382321&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clear-lake-intermediate-school",
      "poi_latitude": "29.5691904",
      "poi_longitude": "-95.1322472",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-284-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-450f-75de-b32a-34a4be8ba08c",
        "storage_key": "property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ65flAXKcQIYRMRb-J5AIYbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_9e22183b1fef555c1ab15cc7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Clear Lake High School",
      "poi_type": "Education",
      "poi_address": "2929 Bay Area Blvd, Houston, TX 77058, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-cd0c-7305-99c0-630058949669.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-cd0c-7305-99c0-630058949669",
        "storage_key": "property/5682633027616768/019f1503-cd0c-7305-99c0-630058949669.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://clearlakehs.ccisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5171226152043434160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clear-lake-high-school",
      "poi_latitude": "29.5823039",
      "poi_longitude": "-95.1057028",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-284-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-450f-75de-b32a-34a4be8ba08c",
        "storage_key": "property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGxWlczScQIYRsFDCdcniw0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_79a4967ffae582d50c37cda2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Kids 'R' Kids Learning Academy of Space Center",
      "poi_type": "Education",
      "poi_address": "151 W Texas Ave, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-c9a0-7670-a466-d423d67e39ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-c9a0-7670-a466-d423d67e39ff",
        "storage_key": "property/5682633027616768/019f1503-c9a0-7670-a466-d423d67e39ff.webp",
        "width": 600,
        "height": 402
      },
      "poi_business_url": "https://kidsrkids.com/space-center/?utm_source=gmb_listing&utm_medium=local&utm_campaign=localpack",
      "poi_directions_map_url": "https://maps.google.com/?cid=7534821981377572502&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kids-r-kids-learning-academy-of-space-center",
      "poi_latitude": "29.5497934",
      "poi_longitude": "-95.1319177",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-557-0062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-450f-75de-b32a-34a4be8ba08c",
        "storage_key": "property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIUNkFIicQIYRlq7QvasQkWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_afa0ed9ee0154034218c69a4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Little People's Greater Life",
      "poi_type": "Education",
      "poi_address": "1655 FM 528 Rd, Webster, TX 77598, USA",
      "poi_short_description": "Relaxed, warm preschool facility, open to kids from 3 months to 12 years old, offering classes in sign language.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-ca08-765b-827b-6cec7dd3b771.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-ca08-765b-827b-6cec7dd3b771",
        "storage_key": "property/5682633027616768/019f1503-ca08-765b-827b-6cec7dd3b771.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://littlepeoplesgreaterlife.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2514353717970862946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-peoples-greater-life",
      "poi_latitude": "29.5238317",
      "poi_longitude": "-95.1405655",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-332-8939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-450f-75de-b32a-34a4be8ba08c",
        "storage_key": "property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5bP5QZacQIYRYgNWh2LH5CI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_ce63f7444b21c7dd835e0243",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "University of Houston-Clear Lake",
      "poi_type": "Education",
      "poi_address": "2700 Bay Area Blvd, Houston, TX 77058, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1500-f102-775a-8050-c10df7ec9d67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-f102-775a-8050-c10df7ec9d67",
        "storage_key": "property/5682633027616768/019f1500-f102-775a-8050-c10df7ec9d67.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.uhcl.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17406779386354668934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-houston-clear-lake",
      "poi_latitude": "29.5824608",
      "poi_longitude": "-95.0989342",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-283-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-450f-75de-b32a-34a4be8ba08c",
        "storage_key": "property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBRIWAM2dQIYRhhVDd6BNkfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_b5ac9ed5254ca0329667b5f6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Bay Area Christian School",
      "poi_type": "Education",
      "poi_address": "4800 W Main St, League City, TX 77573, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.bacschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8298118609957434918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-area-christian-school",
      "poi_latitude": "29.4948692",
      "poi_longitude": "-95.1495971",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-332-4814",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-450f-75de-b32a-34a4be8ba08c",
        "storage_key": "property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDXzoSq-EQIYRJjaSEunWKHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_e3b4d22893a0732fc2ac37d7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Clear Creek High School",
      "poi_type": "Education",
      "poi_address": "2305 E Main St, League City, TX 77573, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-cd0f-773b-a38e-c4613fb14404.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-cd0f-773b-a38e-c4613fb14404",
        "storage_key": "property/5682633027616768/019f1503-cd0f-773b-a38e-c4613fb14404.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://clearcreekhs.ccisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3944614550434849667&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clear-creek-high-school",
      "poi_latitude": "29.5244507",
      "poi_longitude": "-95.0726567",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-284-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-450f-75de-b32a-34a4be8ba08c",
        "storage_key": "property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH3DoqEOdQIYRg6OBvggWvjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_505dfb586453de7b553597be",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Space Center Houston",
      "poi_type": "Entertainment",
      "poi_address": "1601 E NASA Pkwy, Houston, TX 77058, USA",
      "poi_short_description": "Educational center highlighting all eras of U.S. space travel via exhibits, tours & attractions.",
      "poi_long_description": "Educational center highlighting all eras of U.S. space travel via exhibits, tours & attractions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1500-fcc3-7588-a8cf-7424bf6b8b1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-fcc3-7588-a8cf-7424bf6b8b1c",
        "storage_key": "property/5682633027616768/019f1500-fcc3-7588-a8cf-7424bf6b8b1c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.spacecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1436836062198888726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "space-center-houston",
      "poi_latitude": "29.551832",
      "poi_longitude": "-95.0981044",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-244-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b7-7410-93d1-035a9eb42911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b7-7410-93d1-035a9eb42911",
        "storage_key": "property/5682633027616768/019f1501-44b7-7410-93d1-035a9eb42911.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLZlhwACdQIYRFvnVL8mq8BM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_dc0cfc3fe11acbdab3e04e49",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Kemah Boardwalk",
      "poi_type": "Entertainment",
      "poi_address": "215 Kipp Ave, Kemah, TX 77565, USA",
      "poi_short_description": "Family-friendly entertainment including retro rides, a wooden roller coaster & two-story carousel.",
      "poi_long_description": "Family-friendly entertainment including retro rides, a wooden roller coaster & two-story carousel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-d2a7-7329-bf71-aa76aa0560fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-d2a7-7329-bf71-aa76aa0560fb",
        "storage_key": "property/5682633027616768/019f1503-d2a7-7329-bf71-aa76aa0560fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kemahboardwalk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3506269467466928315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kemah-boardwalk",
      "poi_latitude": "29.5473219",
      "poi_longitude": "-95.0202048",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 281-535-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-4511-776c-ae37-7dad29859a46",
        "storage_key": "property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-2iakAJjP4YRuxAq74DFqDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "ec_43e9e6d8eff1b61698faa416",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Bay Area Museum",
      "poi_type": "Entertainment",
      "poi_address": "5000 NASA Road 1, Seabrook, TX 77586, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-d35d-7719-9e55-b57d33306de1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-d35d-7719-9e55-b57d33306de1",
        "storage_key": "property/5682633027616768/019f1503-d35d-7719-9e55-b57d33306de1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://museumbayarea.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6289041424846745937&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-area-museum",
      "poi_latitude": "29.5680042",
      "poi_longitude": "-95.069161",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-326-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b7-7410-93d1-035a9eb42911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b7-7410-93d1-035a9eb42911",
        "storage_key": "property/5682633027616768/019f1501-44b7-7410-93d1-035a9eb42911.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJb04haIidQIYRUfG06dopR1c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_5f3bfd1eda4fffb18098079f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Clear Lake Park",
      "poi_type": "Entertainment",
      "poi_address": "5001 E NASA Pkwy, Seabrook, TX 77586, USA",
      "poi_short_description": "Park with archaeological features on 59 acres with fishing pier, boat launch, playground & trails.",
      "poi_long_description": "Park with archaeological features on 59 acres with fishing pier, boat launch, playground & trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-25dd-7153-9468-74478ad1ee80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-25dd-7153-9468-74478ad1ee80",
        "storage_key": "property/5682633027616768/019f1501-25dd-7153-9468-74478ad1ee80.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.hcp2.com/facilities/list-parks/104-clear-lake-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11356940434028911940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clear-lake-park",
      "poi_latitude": "29.5655933",
      "poi_longitude": "-95.0678815",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 281-326-6539",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b9-768b-9584-8b3430a22dcf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b9-768b-9584-8b3430a22dcf",
        "storage_key": "property/5682633027616768/019f1501-44b9-768b-9584-8b3430a22dcf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIVBSp4-dQIYRRF2QMSf1m50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_6cd36c0126220e69f417dfab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "McIntyre's Webster",
      "poi_type": "Entertainment",
      "poi_address": "806 E NASA Pkwy, Houston, TX 77058, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-d799-728b-aabe-71e1d6e5a868.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-d799-728b-aabe-71e1d6e5a868",
        "storage_key": "property/5682633027616768/019f1503-d799-728b-aabe-71e1d6e5a868.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mcintyresusa.com/webster/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12523493885911261612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcintyres-webster",
      "poi_latitude": "29.54323189999999",
      "poi_longitude": "-95.1088859",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 346-483-0005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-200a-771d-85b0-80d7bc2a2b60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-200a-771d-85b0-80d7bc2a2b60",
        "storage_key": "property/5682633027616768/019f1504-200a-771d-85b0-80d7bc2a2b60.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPSjpAB6dQIYRrGGEQFZjzK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_a7658f2de6574a43f041e11a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Rowdys Dance Hall",
      "poi_type": "Entertainment",
      "poi_address": "803 E NASA Pkwy suite# 140, Webster, TX 77598, USA",
      "poi_short_description": "Dance hall for line dancing and two-stepping featuring DJs, drinks, and music.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-d2f4-733b-848e-a976e1d91e5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-d2f4-733b-848e-a976e1d91e5c",
        "storage_key": "property/5682633027616768/019f1503-d2f4-733b-848e-a976e1d91e5c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rowdysdancehall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2174115757545173246&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rowdys-dance-hall",
      "poi_latitude": "29.5455965",
      "poi_longitude": "-95.1096227",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-984-7802",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-4511-776c-ae37-7dad29859a46",
        "storage_key": "property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN1wvKhWdQIYR_jAPNcMCLB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dance_hall"
    },
    {
      "id": "ec_eea1f4ab62bee42d1c7314ed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Cinemark NASA and XD",
      "poi_type": "Entertainment",
      "poi_address": "20915 Gulf Fwy, Webster, TX 77598, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-d7fa-73e6-b118-18947bfd6e77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-d7fa-73e6-b118-18947bfd6e77",
        "storage_key": "property/5682633027616768/019f1503-d7fa-73e6-b118-18947bfd6e77.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-webster/cinemark-nasa-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMxNTItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7207571296885616326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-nasa-and-xd",
      "poi_latitude": "29.5267127",
      "poi_longitude": "-95.1246749",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-332-0951",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-1fce-72bb-8183-14e7ad7431f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-1fce-72bb-8183-14e7ad7431f7",
        "storage_key": "property/5682633027616768/019f1504-1fce-72bb-8183-14e7ad7431f7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJKdqqjr6cQIYRxi4rPOhvBmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_a2c9a2a7e05f03a02d94edf5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Star Cinema Grill",
      "poi_type": "Entertainment",
      "poi_address": "702 Baybrook Mall, Friendswood, TX 77546, USA",
      "poi_short_description": "Cinema featuring dining options, heated reclining seats and waitstaff service, plus a bar for drinks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-d4f3-7317-87a5-08a31683e313.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-d4f3-7317-87a5-08a31683e313",
        "storage_key": "property/5682633027616768/019f1503-d4f3-7317-87a5-08a31683e313.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.starcinemagrill.net/movie-theater/baybrook",
      "poi_directions_map_url": "https://maps.google.com/?cid=12765688306792673863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "star-cinema-grill",
      "poi_latitude": "29.545818",
      "poi_longitude": "-95.1504157",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-557-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-1fce-72bb-8183-14e7ad7431f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-1fce-72bb-8183-14e7ad7431f7",
        "storage_key": "property/5682633027616768/019f1504-1fce-72bb-8183-14e7ad7431f7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0fTv5JacQIYRRzK8J-HVKLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_87d25c6fa432863abf9d479c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Whiskey River South",
      "poi_type": "Entertainment",
      "poi_address": "1030 W NASA Pkwy, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-d7bd-76ea-b079-c818f0505ed9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-d7bd-76ea-b079-c818f0505ed9",
        "storage_key": "property/5682633027616768/019f1503-d7bd-76ea-b079-c818f0505ed9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://wrsouth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6930806397439481807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whiskey-river-south",
      "poi_latitude": "29.5309535",
      "poi_longitude": "-95.1286938",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 832-369-6881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-4511-776c-ae37-7dad29859a46",
        "storage_key": "property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ31xfsrqdQIYRz5dijrIrL2A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dance_hall"
    },
    {
      "id": "ec_31e36aebd1cd5ac988d8dcf2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Chuck E. Cheese",
      "poi_type": "Entertainment",
      "poi_address": "1541 W Bay Area Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Kid-friendly chain known for its arcade games, pizza parties & play zones.",
      "poi_long_description": "Kid-friendly chain known for its arcade games, pizza parties & play zones.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-d7a0-70cb-b6e9-a6d083968a40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-d7a0-70cb-b6e9-a6d083968a40",
        "storage_key": "property/5682633027616768/019f1503-d7a0-70cb-b6e9-a6d083968a40.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.chuckecheese.com/webster-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=2794592255048165431&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chuck-e-cheese",
      "poi_latitude": "29.53664869999999",
      "poi_longitude": "-95.1494188",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-332-9780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-4511-776c-ae37-7dad29859a46",
        "storage_key": "property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7oBr2SbQIYRNyg0ftliyCY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_4eca0299ef22be316b0d64fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "HCA Houston Healthcare Clear Lake",
      "poi_type": "Health and Wellness",
      "poi_address": "500 W Medical Ctr Blvd, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-1ada-70a8-8c4b-73673cb42441.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-1ada-70a8-8c4b-73673cb42441",
        "storage_key": "property/5682633027616768/019f1501-1ada-70a8-8c4b-73673cb42441.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/clear-lake?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1498573804104781872&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-houston-healthcare-clear-lake",
      "poi_latitude": "29.5408696",
      "poi_longitude": "-95.1271676",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-332-2511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b8-73ed-b70d-c58bcad9d756.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b8-73ed-b70d-c58bcad9d756",
        "storage_key": "property/5682633027616768/019f1501-44b8-73ed-b70d-c58bcad9d756.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJAw22Co6cQIYRMBBfX-8AzBQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_d14487460379267a48a52cc0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Memorial Hermann-GoHealth Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "19419 Gulf Fwy ste.3, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-dbff-730c-a1d7-3b2ccc6e0eba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-dbff-730c-a1d7-3b2ccc6e0eba",
        "storage_key": "property/5682633027616768/019f1503-dbff-730c-a1d7-3b2ccc6e0eba.webp",
        "width": 880,
        "height": 742
      },
      "poi_business_url": "https://www.gohealthuc.com/memorialhermann/locations/clear-lake?utm_source=gmb&utm_medium=organic&utm_content=memorialhermann-clear-lake",
      "poi_directions_map_url": "https://maps.google.com/?cid=4086185230324925044&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-gohealth-urgent-care",
      "poi_latitude": "29.5426101",
      "poi_longitude": "-95.1392669",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 346-788-3461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-4511-776c-ae37-7dad29859a46",
        "storage_key": "property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJszYsmYOcQIYRdAL3Q9ELtTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_259836218c67b2a4022c7010",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1801 W Bay Area Blvd, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-dddc-7703-977c-d8f0a94fb124.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-dddc-7703-977c-d8f0a94fb124",
        "storage_key": "property/5682633027616768/019f1503-dddc-7703-977c-d8f0a94fb124.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/webster-tx-pharmacies/1801-w-bay-area-blvd-webster-tx-77598/storeid=16958?WT.mc_id=LS_GOOGLE_RX_16958",
      "poi_directions_map_url": "https://maps.google.com/?cid=10868780887166009343&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.5360544",
      "poi_longitude": "-95.151189",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-819-4117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-1fe7-7099-9915-13d6839c41d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-1fe7-7099-9915-13d6839c41d8",
        "storage_key": "property/5682633027616768/019f1504-1fe7-7099-9915-13d6839c41d8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxaknB2WbQIYR_78VsaGq1ZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_52944da303891bf4ae016554",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "980 Clear Lake City Blvd, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-deaa-76cd-bd46-dd139a14a958.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-deaa-76cd-bd46-dd139a14a958",
        "storage_key": "property/5682633027616768/019f1503-deaa-76cd-bd46-dd139a14a958.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/webster-tx-pharmacies/980-clear-lake-city-blvd-at-highway-3-webster-tx-77598/storeid=8442?WT.mc_id=LS_GOOGLE_RX_8442",
      "poi_directions_map_url": "https://maps.google.com/?cid=3787374843318836814&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.5787319",
      "poi_longitude": "-95.1585613",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-480-4410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-1fe7-7099-9915-13d6839c41d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-1fe7-7099-9915-13d6839c41d8",
        "storage_key": "property/5682633027616768/019f1504-1fe7-7099-9915-13d6839c41d8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT7kSAeybQIYRTh5Fh1p1jzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_e6f33d0f6a727d5d2e4c079e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "H-E-B Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "18611 Eastfield Dr, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-e052-740b-ab8c-c443f5e53e57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-e052-740b-ab8c-c443f5e53e57",
        "storage_key": "property/5682633027616768/019f1503-e052-740b-ab8c-c443f5e53e57.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/pharmacy/common/landing?utm_source=google&utm_medium=organic&utm_campaign=gmb_pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=13838597757920388593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-pharmacy",
      "poi_latitude": "29.5521819",
      "poi_longitude": "-95.1493096",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-488-0179",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-1fe7-7099-9915-13d6839c41d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-1fe7-7099-9915-13d6839c41d8",
        "storage_key": "property/5682633027616768/019f1504-1fe7-7099-9915-13d6839c41d8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4b0XLqbQIYR8aVcPleTDMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_f9b6bf1c1a87a177d840f29c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "560 El Dorado Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Relaxed chain offering numerous machines and various classes, along with massage chairs, tanning beds and hydromassage.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-12ab-7144-8d60-fd28dbefc930.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-12ab-7144-8d60-fd28dbefc930",
        "storage_key": "property/5682633027616768/019f1501-12ab-7144-8d60-fd28dbefc930.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/webster-el-dorado-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=4169089902244546256&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "29.55978",
      "poi_longitude": "-95.14106",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 832-500-5510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-4511-776c-ae37-7dad29859a46",
        "storage_key": "property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYduIUXicQIYR0Eb0Yy2V2zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_10864b5e6de0bb4c72ce8c15",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "SteelWorX Gym and Training Center",
      "poi_type": "Health and Wellness",
      "poi_address": "410 Genesis Blvd Ste D, Webster, TX 77598, USA",
      "poi_short_description": "Clean gym offering strength-training tools, plus 24/7 access.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-e86c-728f-8d1f-05db209c4a11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-e86c-728f-8d1f-05db209c4a11",
        "storage_key": "property/5682633027616768/019f1503-e86c-728f-8d1f-05db209c4a11.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.steelworxgym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18159982048443812026&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "steelworx-gym-and-training-center",
      "poi_latitude": "29.5283145",
      "poi_longitude": "-95.136393",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-370-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-4511-776c-ae37-7dad29859a46",
        "storage_key": "property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyxt8j6KcQIYRusj2FHU3Bfw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_f6e83500abf67e9ece55aafb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Fitness Connection",
      "poi_type": "Health and Wellness",
      "poi_address": "20761 Gulf Fwy, Webster, TX 77598, USA",
      "poi_short_description": "Welcoming fitness center featuring cardio machines, free weights, cycling and Zumba classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-13d2-7344-80f5-bc1f062917f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-13d2-7344-80f5-bc1f062917f7",
        "storage_key": "property/5682633027616768/019f1501-13d2-7344-80f5-bc1f062917f7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://fitnessconnection.com/gyms/clear-lake/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9895407264515616104&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fitness-connection",
      "poi_latitude": "29.5279856",
      "poi_longitude": "-95.1269106",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-316-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-4511-776c-ae37-7dad29859a46",
        "storage_key": "property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRbHSVz6dQIYRaO1FnXqMU4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_2fa95e1fed52aade58fe37d6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "19801 Gulf Fwy Ste 1000, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-06ee-76d5-ae79-acc69c913e94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-06ee-76d5-ae79-acc69c913e94",
        "storage_key": "property/5682633027616768/019f1501-06ee-76d5-ae79-acc69c913e94.webp",
        "width": 1280,
        "height": 906
      },
      "poi_business_url": "https://www.eosfitness.com/gym/webster-gulf-fwy-w-bay-area-blvd?utm_source=local&utm_medium=organic&utm_content=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1455667643795358548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "29.5383872",
      "poi_longitude": "-95.1349362",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 346-781-9898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-4511-776c-ae37-7dad29859a46",
        "storage_key": "property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCV-nKQCdQIYRVMNzcwKSMxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_c779463fae74455de078f876",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "FS8 Webster",
      "poi_type": "Health and Wellness",
      "poi_address": "935 W Bay Area Blvd, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-ecb2-7552-abef-6e899b0b1091.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-ecb2-7552-abef-6e899b0b1091",
        "storage_key": "property/5682633027616768/019f1503-ecb2-7552-abef-6e899b0b1091.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://fs8.com/webster",
      "poi_directions_map_url": "https://maps.google.com/?cid=9534223320737144788&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fs8-webster",
      "poi_latitude": "29.5418179",
      "poi_longitude": "-95.1370785",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-845-3686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-450f-75de-b32a-34a4be8ba08c",
        "storage_key": "property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ6TKDQCdQIYR1F_IgZhdUIQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_9b7dcbe67774f55ec5c61551",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Great Wolf Lodge | Webster",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1000 Great Wolf Wy, Webster, TX 77598, USA",
      "poi_short_description": "Relaxed chain hotel featuring spacious rooms, a spa, and indoor and outdoor water parks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-f1df-7729-8310-6a62a3bf0441.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-f1df-7729-8310-6a62a3bf0441",
        "storage_key": "property/5682633027616768/019f1503-f1df-7729-8310-6a62a3bf0441.webp",
        "width": 1280,
        "height": 881
      },
      "poi_business_url": "https://www.greatwolf.com/webster?utm_source=google&utm_medium=organic&utm_campaign=gmb-webster",
      "poi_directions_map_url": "https://maps.google.com/?cid=16707537034578491455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "great-wolf-lodge--webster",
      "poi_latitude": "29.5183867",
      "poi_longitude": "-95.1156706",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 888-981-9653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-1fe0-76f2-9067-7eec9820e909.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-1fe0-76f2-9067-7eec9820e909",
        "storage_key": "property/5682633027616768/019f1504-1fe0-76f2-9067-7eec9820e909.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJUZExrdydQIYRP_i7oWkY3ec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "resort_hotel"
    },
    {
      "id": "ec_2fa0a08cda6d3a25e0624360",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Siabara Pollinator Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "900 E NASA Pkwy, Houston, TX 77058, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6483103438216351712&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "siabara-pollinator-garden",
      "poi_latitude": "29.5446478",
      "poi_longitude": "-95.1075444",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-4511-776c-ae37-7dad29859a46",
        "storage_key": "property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRWzTDACdQIYR4M__ZDqc-Fk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "ec_3f6e33ea247e474b09d223ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Walnut Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Walnut Park, 400 N Walnut, Webster, TX 77598, USA",
      "poi_short_description": "Compact green space with well-kept, tree-lined walking paths & a children's playground.",
      "poi_long_description": "Compact green space with well-kept, tree-lined walking paths & a children's playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-efcf-7772-bf04-c90a25e96ca5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-efcf-7772-bf04-c90a25e96ca5",
        "storage_key": "property/5682633027616768/019f1503-efcf-7772-bf04-c90a25e96ca5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofwebster.com/887/Walnut-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8105699125215052008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walnut-park",
      "poi_latitude": "29.5368433",
      "poi_longitude": "-95.1249188",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-332-1826",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b9-768b-9584-8b3430a22dcf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b9-768b-9584-8b3430a22dcf",
        "storage_key": "property/5682633027616768/019f1501-44b9-768b-9584-8b3430a22dcf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrVuS_JKcQIYR6ECjlmg6fXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_1241150b118b6944212f5f89",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Green Acres Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "901 Whitehall Ln, Houston, TX 77058, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-fcd3-7232-9eb2-f47696f7cc68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-fcd3-7232-9eb2-f47696f7cc68",
        "storage_key": "property/5682633027616768/019f1503-fcd3-7232-9eb2-f47696f7cc68.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13919799271883647312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "green-acres-park",
      "poi_latitude": "29.5410095",
      "poi_longitude": "-95.1037134",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-332-1826",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b9-768b-9584-8b3430a22dcf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b9-768b-9584-8b3430a22dcf",
        "storage_key": "property/5682633027616768/019f1501-44b9-768b-9584-8b3430a22dcf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8bOXLv2cQIYRUKldAbAPLcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_3245fb31b8498134d23ce5e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "McWhirter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "409 E NASA Rd, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://cityofwebster.com/890/McWhirter-Pocket-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1177561200594925310&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcwhirter-park",
      "poi_latitude": "29.5352031",
      "poi_longitude": "-95.1210929",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b9-768b-9584-8b3430a22dcf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b9-768b-9584-8b3430a22dcf",
        "storage_key": "property/5682633027616768/019f1501-44b9-768b-9584-8b3430a22dcf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQVYGb2edQIYR_ja-RqyJVxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_8ea603e3133edafd682faff3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Texas Avenue Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17100 N Texas Ave, Webster, TX 77598, USA",
      "poi_short_description": "Urban park with baseball, softball & basketball fields, tennis courts, playgrounds & walking track.",
      "poi_long_description": "Urban park with baseball, softball & basketball fields, tennis courts, playgrounds & walking track.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-eec8-77ad-bc51-10a9b234268d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-eec8-77ad-bc51-10a9b234268d",
        "storage_key": "property/5682633027616768/019f1503-eec8-77ad-bc51-10a9b234268d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cityofwebster.com/886/Texas-Avenue-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6453574986490467572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-avenue-park",
      "poi_latitude": "29.5405465",
      "poi_longitude": "-95.1331001",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-332-1826",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b9-768b-9584-8b3430a22dcf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b9-768b-9584-8b3430a22dcf",
        "storage_key": "property/5682633027616768/019f1501-44b9-768b-9584-8b3430a22dcf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKx-fZoWcQIYR9FQc-UG0j1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_16ef1d17220eba61068a7fd0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Challenger Seven Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2301 W Nasa Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Challenger Space Shuttle disaster memorial & learning center in a 300-acre park with wetlands.",
      "poi_long_description": "Challenger Space Shuttle disaster memorial & learning center in a 300-acre park with wetlands.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-2439-74de-850b-9f9d27c386fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-2439-74de-850b-9f9d27c386fb",
        "storage_key": "property/5682633027616768/019f1501-2439-74de-850b-9f9d27c386fb.webp",
        "width": 1280,
        "height": 921
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13827686735360768045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "challenger-seven-memorial-park",
      "poi_latitude": "29.5099629",
      "poi_longitude": "-95.1360548",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-332-1903",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b9-768b-9584-8b3430a22dcf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b9-768b-9584-8b3430a22dcf",
        "storage_key": "property/5682633027616768/019f1501-44b9-768b-9584-8b3430a22dcf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-95kEAGdQIYRLTiP1tLP5b8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ecaa71fcd89348be10e8c6bf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Taylor Lake Village Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "500 Kirby Blvd, Taylor Lake Village, TX 77586, USA",
      "poi_short_description": "Spacious 40-acre park with a jogging trail, sports fields, a fishing pier & a picnic/BBQ pavilion.",
      "poi_long_description": "Spacious 40-acre park with a jogging trail, sports fields, a fishing pier & a picnic/BBQ pavilion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-f169-75b2-8e05-48a36a1a1aff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-f169-75b2-8e05-48a36a1a1aff",
        "storage_key": "property/5682633027616768/019f1503-f169-75b2-8e05-48a36a1a1aff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.taylorlakevillage.us/parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=11748376391337572264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taylor-lake-village-community-park",
      "poi_latitude": "29.574596",
      "poi_longitude": "-95.0566845",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 281-326-2843",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b9-768b-9584-8b3430a22dcf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b9-768b-9584-8b3430a22dcf",
        "storage_key": "property/5682633027616768/019f1501-44b9-768b-9584-8b3430a22dcf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMWwRiXRiP4YRqPdCFRWeCqM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d8fae4fa2988e280fb3affb1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Dr Ned and Fay Dudney Clear Creek Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "GWH6+RH, League City, TX 77573, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-f6e9-768b-b357-02ef52012d0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-f6e9-768b-b357-02ef52012d0c",
        "storage_key": "property/5682633027616768/019f1503-f6e9-768b-b357-02ef52012d0c.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9310513640100585320&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dr-ned-and-fay-dudney-clear-creek-nature-center",
      "poi_latitude": "29.5295178",
      "poi_longitude": "-95.0885056",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b9-768b-9584-8b3430a22dcf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b9-768b-9584-8b3430a22dcf",
        "storage_key": "property/5682633027616768/019f1501-44b9-768b-9584-8b3430a22dcf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnUsAbgCdQIYRaN-fktOWNYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_6bcdfc636bcfef57a467f39f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Armand Bayou Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8500 Bay Area Blvd, Pasadena, TX 77507, USA",
      "poi_short_description": "Vast nature preserve with walking trails & many educational activities, such as guided canoe trips.",
      "poi_long_description": "Vast nature preserve with walking trails & many educational activities, such as guided canoe trips.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-2307-71dd-af03-6b1c6fa84082.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-2307-71dd-af03-6b1c6fa84082",
        "storage_key": "property/5682633027616768/019f1501-2307-71dd-af03-6b1c6fa84082.webp",
        "width": 1024,
        "height": 682
      },
      "poi_business_url": "http://www.abnc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9274310725211214610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "armand-bayou-nature-center",
      "poi_latitude": "29.596388",
      "poi_longitude": "-95.078088",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-474-2551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b9-768b-9584-8b3430a22dcf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b9-768b-9584-8b3430a22dcf",
        "storage_key": "property/5682633027616768/019f1501-44b9-768b-9584-8b3430a22dcf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7TKtGuKdQIYRElPPmHf4tIA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_5fca30e3b12407fa51e2c9ae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "El Dorado Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "203 W El Dorado Blvd, Friendswood, TX 77546, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1503-fd26-7038-b87d-673ffe0e0798.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-fd26-7038-b87d-673ffe0e0798",
        "storage_key": "property/5682633027616768/019f1503-fd26-7038-b87d-673ffe0e0798.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17653152942922900114&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-dorado-park--ride",
      "poi_latitude": "29.5491606",
      "poi_longitude": "-95.1583549",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-1fe9-72da-b620-0ab38ea7c382.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-1fe9-72da-b620-0ab38ea7c382",
        "storage_key": "property/5682633027616768/019f1504-1fe9-72da-b620-0ab38ea7c382.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJXZUQ43WbQIYRkqKPOBKZ_PQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_7584d0ef2f14a59348d5713d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Bay Area Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "801 Bay Area Blvd, Houston, TX 77062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-0314-7008-a944-e394e7b7cf8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-0314-7008-a944-e394e7b7cf8c",
        "storage_key": "property/5682633027616768/019f1504-0314-7008-a944-e394e7b7cf8c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17875593883594312405&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-area-park--ride",
      "poi_latitude": "29.552879",
      "poi_longitude": "-95.124182",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-1fe9-72da-b620-0ab38ea7c382.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-1fe9-72da-b620-0ab38ea7c382",
        "storage_key": "property/5682633027616768/019f1504-1fe9-72da-b620-0ab38ea7c382.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJGf2WA96dQIYR1crInO3dEvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_b5a34274cbc45eaf3f29e2a6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Fuqua Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "11755 Sabo Rd, Houston, TX 77089, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-08d6-71b9-8a2b-70758318461e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-08d6-71b9-8a2b-70758318461e",
        "storage_key": "property/5682633027616768/019f1504-08d6-71b9-8a2b-70758318461e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6784345919959218921&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fuqua-park--ride",
      "poi_latitude": "29.6098305",
      "poi_longitude": "-95.2169622",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-1fe9-72da-b620-0ab38ea7c382.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-1fe9-72da-b620-0ab38ea7c382",
        "storage_key": "property/5682633027616768/019f1504-1fe9-72da-b620-0ab38ea7c382.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJC_ramuWZQIYR6TqKUKvWJl4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_59ef8ebc7c50f791c3eee577",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Monroe Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "8833 1/2 Gulf Fwy, Houston, TX 77017, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-0765-762d-919f-b30a51f108ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-0765-762d-919f-b30a51f108ac",
        "storage_key": "property/5682633027616768/019f1504-0765-762d-919f-b30a51f108ac.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14541391259546629484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "monroe-park-and-ride",
      "poi_latitude": "29.6639737",
      "poi_longitude": "-95.2545992",
      "poi_miles_from_property": "10.8 mi",
      "poi_walking_minutes": "3 hours 59 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-1fe9-72da-b620-0ab38ea7c382.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-1fe9-72da-b620-0ab38ea7c382",
        "storage_key": "property/5682633027616768/019f1504-1fe9-72da-b620-0ab38ea7c382.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJq5iUHMeXQIYRbDU_lU5mzck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_712c7268286f044931b0f587",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "South Point Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "12410 Kurland Dr, Houston, TX 77034, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-0299-7324-98a3-296285188ee5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-0299-7324-98a3-296285188ee5",
        "storage_key": "property/5682633027616768/019f1504-0299-7324-98a3-296285188ee5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11003864892047460788&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-point-park--ride",
      "poi_latitude": "29.6138524",
      "poi_longitude": "-95.2082679",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-1fe9-72da-b620-0ab38ea7c382.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-1fe9-72da-b620-0ab38ea7c382",
        "storage_key": "property/5682633027616768/019f1504-1fe9-72da-b620-0ab38ea7c382.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJDS9OeemZQIYRtInhftGUtZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_cde3395e7d836e15bb94c3c1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Baybrook Mall",
      "poi_type": "Transportation & Transit",
      "poi_address": "500 Baybrook Mall, Friendswood, TX 77546, USA",
      "poi_short_description": "Casual shopping plaza with stores for apparel, footwear, jewelry, home goods & kids, plus dining.",
      "poi_long_description": "Casual shopping plaza with stores for apparel, footwear, jewelry, home goods & kids, plus dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1500-e7a2-73b6-af65-9436dbaead1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-e7a2-73b6-af65-9436dbaead1d",
        "storage_key": "property/5682633027616768/019f1500-e7a2-73b6-af65-9436dbaead1d.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://www.baybrookmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3962758813461213470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baybrook-mall",
      "poi_latitude": "29.5427508",
      "poi_longitude": "-95.148508",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-667-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44ca-77cf-8a0b-8a3f09e07c59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44ca-77cf-8a0b-8a3f09e07c59",
        "storage_key": "property/5682633027616768/019f1501-44ca-77cf-8a0b-8a3f09e07c59.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOf21c3qbQIYRHnHnLiWM_jY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_6478deaf070cf0526c7798b0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Joint Reserve Base Ellington",
      "poi_type": "Transportation & Transit",
      "poi_address": "11210 Blume Ave, Houston, TX 77034, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-020b-778f-af86-8767d4bce761.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-020b-778f-af86-8767d4bce761",
        "storage_key": "property/5682633027616768/019f1504-020b-778f-af86-8767d4bce761.webp",
        "width": 1080,
        "height": 979
      },
      "poi_business_url": "https://www.goang.com/locations/texas/ellington-field-joint-reserve-base.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=1653394884355412175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joint-reserve-base-ellington",
      "poi_latitude": "29.60759419999999",
      "poi_longitude": "-95.1757853",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-929-2273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-200a-771d-85b0-875f433a6234.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-200a-771d-85b0-875f433a6234",
        "storage_key": "property/5682633027616768/019f1504-200a-771d-85b0-875f433a6234.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxXgJrmiZQIYRz9BzI-MJ8hY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_6bef1b72322397964e51055b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "William P. Hobby Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7800 Airport Blvd, Houston, TX 77061, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-0b45-7146-8966-d521d3ce7abc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-0b45-7146-8966-d521d3ce7abc",
        "storage_key": "property/5682633027616768/019f1504-0b45-7146-8966-d521d3ce7abc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fly2houston.com/hou/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10811035190079821913&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-p-hobby-airport",
      "poi_latitude": "29.6459141",
      "poi_longitude": "-95.2768951",
      "poi_miles_from_property": "11.4 mi",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 713-640-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44ff-731a-84f9-84ecc9214cfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44ff-731a-84f9-84ecc9214cfd",
        "storage_key": "property/5682633027616768/019f1501-44ff-731a-84f9-84ecc9214cfd.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJI2ZP70-WQIYRWZj03jmDCJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_945192b768103a3000d14308",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "NASA Johnson Space Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Clear Lake, 2101 E NASA Pkwy, Houston, TX 77058, USA",
      "poi_short_description": "NASA's 1,700-acre facility used for mission control & training shuttle & space station astronauts.",
      "poi_long_description": "NASA's 1,700-acre facility used for mission control & training shuttle & space station astronauts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-07d5-755e-950c-52143e50ae9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-07d5-755e-950c-52143e50ae9a",
        "storage_key": "property/5682633027616768/019f1504-07d5-755e-950c-52143e50ae9a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nasa.gov/centers/johnson/home/index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=2389238764222131620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nasa-johnson-space-center",
      "poi_latitude": "29.552908",
      "poi_longitude": "-95.0933748",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-483-0123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-450f-75de-b32a-34a4be8ba08c",
        "storage_key": "property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc29kHLCdQIYRpK0NUf9HKCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "research_institute"
    },
    {
      "id": "ec_9414fccd7261f0f20c59fe3c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Space Center Houston",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1601 E NASA Pkwy, Houston, TX 77058, USA",
      "poi_short_description": "Educational center highlighting all eras of U.S. space travel via exhibits, tours & attractions.",
      "poi_long_description": "Educational center highlighting all eras of U.S. space travel via exhibits, tours & attractions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1500-fcc3-7588-a8cf-7424bf6b8b1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-fcc3-7588-a8cf-7424bf6b8b1c",
        "storage_key": "property/5682633027616768/019f1500-fcc3-7588-a8cf-7424bf6b8b1c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.spacecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1436836062198888726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "space-center-houston",
      "poi_latitude": "29.551832",
      "poi_longitude": "-95.0981044",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-244-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b7-7410-93d1-035a9eb42911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b7-7410-93d1-035a9eb42911",
        "storage_key": "property/5682633027616768/019f1501-44b7-7410-93d1-035a9eb42911.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLZlhwACdQIYRFvnVL8mq8BM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_74e040d8da54bed903267cca",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "University of Houston-Clear Lake",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2700 Bay Area Blvd, Houston, TX 77058, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1500-f102-775a-8050-c10df7ec9d67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-f102-775a-8050-c10df7ec9d67",
        "storage_key": "property/5682633027616768/019f1500-f102-775a-8050-c10df7ec9d67.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.uhcl.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17406779386354668934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-houston-clear-lake",
      "poi_latitude": "29.5824608",
      "poi_longitude": "-95.0989342",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-283-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-450f-75de-b32a-34a4be8ba08c",
        "storage_key": "property/5682633027616768/019f1501-450f-75de-b32a-34a4be8ba08c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBRIWAM2dQIYRhhVDd6BNkfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_90118eee73f29e1025de4370",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "UTMB Health Clear Lake Campus Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 Blossom St, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-0f1f-764d-94d4-0f0d0ee10835.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-0f1f-764d-94d4-0f0d0ee10835",
        "storage_key": "property/5682633027616768/019f1504-0f1f-764d-94d4-0f0d0ee10835.webp",
        "width": 1000,
        "height": 565
      },
      "poi_business_url": "https://www.utmbhealth.com/clc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3313281454647947128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "utmb-health-clear-lake-campus-hospital",
      "poi_latitude": "29.5447851",
      "poi_longitude": "-95.1259629",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 832-632-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b8-73ed-b70d-c58bcad9d756.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b8-73ed-b70d-c58bcad9d756",
        "storage_key": "property/5682633027616768/019f1501-44b8-73ed-b70d-c58bcad9d756.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJh0-iflqdQIYReC8use0j-y0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_45dbebb5cb16f094c553af9d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "HCA Houston Healthcare Clear Lake",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 W Medical Ctr Blvd, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-1ada-70a8-8c4b-73673cb42441.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-1ada-70a8-8c4b-73673cb42441",
        "storage_key": "property/5682633027616768/019f1501-1ada-70a8-8c4b-73673cb42441.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/clear-lake?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1498573804104781872&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-houston-healthcare-clear-lake",
      "poi_latitude": "29.5408696",
      "poi_longitude": "-95.1271676",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-332-2511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-44b8-73ed-b70d-c58bcad9d756.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-44b8-73ed-b70d-c58bcad9d756",
        "storage_key": "property/5682633027616768/019f1501-44b8-73ed-b70d-c58bcad9d756.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJAw22Co6cQIYRMBBfX-8AzBQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_40b6470a4edb4eb994fd14ca",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "The Boeing Company",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3700 Bay Area Blvd, Houston, TX 77058, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.boeing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9991633183398237187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-boeing-company",
      "poi_latitude": "29.5913555",
      "poi_longitude": "-95.1004799",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-226-4141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-4511-776c-ae37-7dad29859a46",
        "storage_key": "property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvXDgR9OdQIYRAxR1PnFpqYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_09e30303db6b985de3d4f5db",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Amentum",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2224 Bay Area Blvd, Houston, TX 77058, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-167f-732e-83bf-92eac7a08d35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-167f-732e-83bf-92eac7a08d35",
        "storage_key": "property/5682633027616768/019f1504-167f-732e-83bf-92eac7a08d35.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amentum.com/markets/space/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18112318265827753219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amentum",
      "poi_latitude": "29.5712257",
      "poi_longitude": "-95.10914710000002",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-461-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-4511-776c-ae37-7dad29859a46",
        "storage_key": "property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3UVHHEmcQIYRA3175X_hW_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "ec_03a238fd8857fb5e5a1642c1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "poi_name": "Houston Spaceport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "510 Ellington Field, Houston, TX 77034, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1504-194d-71d6-9a82-62c7afdbb9b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-194d-71d6-9a82-62c7afdbb9b5",
        "storage_key": "property/5682633027616768/019f1504-194d-71d6-9a82-62c7afdbb9b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fly2houston.com/spaceport",
      "poi_directions_map_url": "https://maps.google.com/?cid=15880491047896326841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-spaceport",
      "poi_latitude": "29.6039194",
      "poi_longitude": "-95.1759009",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-233-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-4511-776c-ae37-7dad29859a46",
        "storage_key": "property/5682633027616768/019f1501-4511-776c-ae37-7dad29859a46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcb9og3qZQIYRuaKhOHjWYtw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    }
  ],
  "office_hours": [
    {
      "id": "custom_e88d1fa9-7545-410d-9805-f211366c644c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_10aa9ee0-15cb-4fd5-95a5-1eff94fad94c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_1b66e7b4-4abd-4d15-9c46-7c16f1f1bee7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_3bc101b3-44fd-4035-bb2b-14ce69150aa1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_a41f23db-7873-40a7-98a3-66952cb3f3a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_8ccbb069-5b57-442a-9fbd-c73226920382",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_9360214a-ffa2-46fe-94b7-b344bd8143ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_56c084fc-def1-4171-8aed-00b084c10361",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "rating": "5.0",
      "name": "Ruben Saucedo",
      "text": "The McAlister Apartments Team welcomed us with open arms and helped us in every way they could. This has been the first apartments that made our transition into our new home so easy and pleasant. I just want to personally thank Sarah and Maria for making us feel so welcome. I appreciate you guys.🥰",
      "date": "2026-06-01",
      "title": ""
    },
    {
      "id": "custom_43d63b4d-1115-4bcc-bbdb-49b09d6538d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "rating": "5.0",
      "name": "Mighty Man Movers",
      "text": "We recently completed a move at McAlister Apartments, and the experience was excellent from start to finish. The office staff was professional, responsive, and easy to work with, which made coordination smooth for both our crew and the resident.\nAccess to the property was well-organized, parking and loading areas were clearly communicated, and everything ran efficiently. It’s always a pleasure working with apartment communities that value organization and cooperation—it truly helps create a stress-free moving day for everyone involved.\nWe appreciate the professionalism of the McAlister Apartments team and look forward to working with them again in the future.\n— Mighty Man Movers",
      "date": "2026-02-03",
      "title": ""
    },
    {
      "id": "custom_f60e433b-648e-43f5-a65a-432978dae42f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "rating": "4.0",
      "name": "Robert E. Howard",
      "text": "As far as management goes, this was the best apartment community I have lived in so far. From day one, the manager Candice was awesome. All of my maintenance request were completed in a timely fashion. A few things needed tweaking but I took care of them myself. The entry gate always works and if broken it’s fixed in 24 hours or less. I wasn’t quite ready to move out on my move out date and they gave me a 3day extension without paying extra. I didn’t have a problem with parking because I worked nights. I will definitely move back here if I work in the area again.",
      "date": "2019-09-15",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_a57666e84df48d481f90c6fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f14c4-06e2-727d-8234-ee58fc22b821.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-06e2-727d-8234-ee58fc22b821",
        "storage_key": "property/5682633027616768/019f14c4-06e2-727d-8234-ee58fc22b821.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=bHFocZPSJa8"
    },
    {
      "id": "ec_7562add200587dd24f697062",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f14c4-07c0-701f-a0a5-57cffd82d960.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-07c0-701f-a0a5-57cffd82d960",
        "storage_key": "property/5682633027616768/019f14c4-07c0-701f-a0a5-57cffd82d960.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Pool",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=hPAdXKJDkNz"
    },
    {
      "id": "ec_07cd19d1d0b081c4e6d2f861",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f14c4-07cf-7548-98ad-a34173ba6302.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-07cf-7548-98ad-a34173ba6302",
        "storage_key": "property/5682633027616768/019f14c4-07cf-7548-98ad-a34173ba6302.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "1BR, 1BA - 552SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=622yMGKR5AE"
    },
    {
      "id": "ec_930a534b02a9f665b5c7f1c0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f14c4-1261-719b-af66-1de808cf82b1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-1261-719b-af66-1de808cf82b1",
        "storage_key": "property/5682633027616768/019f14c4-1261-719b-af66-1de808cf82b1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 1.5BA - 850SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=HgL3jq4FHcA"
    },
    {
      "id": "ec_f44d906bde7a14e49a6cc45e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019d02f1-1c1b-75be-b053-bcca4201054e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern living room with plush sofa, glass coffee table, and TV, opening to a bedroom with a navy accent wall.",
        "public_id": "019d02f1-1c1b-75be-b053-bcca4201054e",
        "storage_key": "property/5682633027616768/019d02f1-1c1b-75be-b053-bcca4201054e.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "1BR, 1BA - 664SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7K3Pj4pcvUa"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-b138-7491-9605-eb0336cc06cf",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "mcalister",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768"
    },
    {
      "lead_collector_id": "0198aa45-b19c-70a3-a120-305d8420c311",
      "lead_source": "FACEBOOK_ADS",
      "name": "mcalister",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768"
    },
    {
      "lead_collector_id": "0198aa45-b202-7408-867c-36c76c16eaf7",
      "lead_source": "LANDING_PAGE",
      "name": "mcalister",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "page_item_url": "discover-one-bedroom-apartments-for-rent-webster-tx",
      "search_query": "One Bedroom Apartments For Rent In Webster TX",
      "category": "Floorplan",
      "h1_title": "Discover One Bedroom Apartments For Rent In Webster TX",
      "h2_subtitle": "Experience the perfect blend of comfort and style at McAlister. Our one-bedroom apartments offer spacious layouts and premium amenities in a prime location.",
      "page_copy": "Welcome to McAlister, where our one-bedroom apartments for rent in Webster, TX, redefine modern living. Nestled on El Dorado Boulevard, our community is conveniently located near I-45 and Baybrook Mall, providing easy access to shopping, dining, and entertainment. Each apartment features a light-filled, spacious floor plan with vaulted ceilings, crown molding, and vinyl plank-style flooring. Enjoy your private outdoor space with a balcony or patio, perfect for relaxation. Our community amenities include a sparkling swimming pool, heated spa, and a pet-friendly walking area, ensuring a vibrant lifestyle. Discover the ideal home at McAlister today.",
      "featured_image": "https://irp.cdn-website.com/493be48b/dms3rep/multi/05_qwwlpx.webp",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-d4d4-726c-aecc-489665d83699",
        "storage_key": "property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "McAlister | One Bedroom Apartments For Rent In Webster TX",
      "seo_description": "Explore McAlister's one bedroom apartments for rent in Webster, TX. Enjoy spacious layouts, premium amenities, and a prime location near I-45 and Baybrook Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "page_item_url": "explore-two-bedrooms-apartments-for-rent-webster-tx",
      "search_query": "Two Bedrooms Apartments For Rent In Webster TX",
      "category": "Floorplan",
      "h1_title": "Explore Two Bedrooms Apartments For Rent In Webster TX",
      "h2_subtitle": "Find your perfect home at McAlister with our spacious two-bedroom apartments. Enjoy modern amenities and a convenient location near I-45 and Baybrook Mall.",
      "page_copy": "At McAlister, our two bedrooms apartments for rent in Webster, TX, offer the ideal combination of space and style. Situated on El Dorado Boulevard, our community provides easy access to I-45 and Baybrook Mall, making it a prime location for shopping and entertainment. Each apartment features a spacious floor plan with vaulted ceilings, crown molding, and vinyl plank-style flooring. Enjoy your own private outdoor space with a balcony or patio, perfect for relaxation. Our community amenities include a sparkling swimming pool, heated spa, and a pet-friendly walking area, ensuring a vibrant lifestyle. Discover the perfect two-bedroom home at McAlister today.",
      "featured_image": "https://irp.cdn-website.com/493be48b/dms3rep/multi/05_qwwlpx.webp",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-d4d4-726c-aecc-489665d83699",
        "storage_key": "property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "McAlister | Two Bedrooms Apartments For Rent In Webster TX",
      "seo_description": "Discover McAlister's two bedrooms apartments for rent in Webster, TX. Enjoy spacious layouts, modern amenities, and a prime location near I-45 and Baybrook Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Pool at McAlister",
      "h2_subtitle": "Enjoy resort-style living at McAlister with our stunning pool and modern amenities. Discover your new home in a prime Webster, TX location today.",
      "page_copy": "Discover the perfect blend of comfort and convenience at McAlister, where our apartments for rent near me with pool redefine luxury living. Located on El Dorado Boulevard, our community offers easy access to I-45 and Baybrook Mall, making it an ideal choice for those seeking a vibrant lifestyle. Each apartment features a spacious floor plan with vaulted ceilings, crown molding, and vinyl plank-style flooring. Step outside to your private balcony or patio, or take a dip in our sparkling swimming pool. Our community also features a heated spa, fitness center, and pet-friendly walking area, ensuring a well-rounded living experience. Find your new home at McAlister today.",
      "featured_image": "https://irp.cdn-website.com/493be48b/dms3rep/multi/05_qwwlpx.webp",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-d4d4-726c-aecc-489665d83699",
        "storage_key": "property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "McAlister | Apartments For Rent Near Me with Pool",
      "seo_description": "Explore McAlister's apartments for rent near me with pool. Enjoy modern amenities, a prime Webster, TX location, and a resort-style pool for ultimate relaxation.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Fitness Center",
      "h2_subtitle": "Elevate your lifestyle at McAlister with our state-of-the-art fitness center. Enjoy modern living in a prime Webster, TX location with exceptional amenities.",
      "page_copy": "Welcome to McAlister, where our apartments for rent near me with fitness center offer a perfect blend of luxury and convenience. Situated on El Dorado Boulevard, our community provides easy access to I-45 and Baybrook Mall, making it an ideal location for those seeking a dynamic lifestyle. Each apartment features a spacious floor plan with vaulted ceilings, crown molding, and vinyl plank-style flooring. Enjoy your private outdoor space with a balcony or patio, and take advantage of our state-of-the-art fitness center to maintain your active lifestyle. Our community also includes a sparkling swimming pool, heated spa, and pet-friendly walking area, ensuring a comprehensive living experience. Discover your new home at McAlister today.",
      "featured_image": "https://irp.cdn-website.com/493be48b/dms3rep/multi/05_qwwlpx.webp",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-d4d4-726c-aecc-489665d83699",
        "storage_key": "property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "McAlister | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Explore McAlister's apartments for rent near me with fitness center. Enjoy modern amenities, a prime Webster, TX location, and a state-of-the-art fitness center.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-walk-in-closets",
      "search_query": "Apartments For Rent Near Me with Walk-In Closets",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Walk-In Closets",
      "h2_subtitle": "Enjoy spacious living at McAlister with walk-in closets and modern amenities. Find your perfect home in Webster, TX, with a prime location and exceptional features.",
      "page_copy": "Welcome to McAlister, where our apartments for rent near me with walk-in closets offer the perfect blend of space and style. Located on El Dorado Boulevard, our community is ideally situated near I-45 and Baybrook Mall, providing easy access to shopping and entertainment. Each apartment features a spacious floor plan with vaulted ceilings, crown molding, and vinyl plank-style flooring. Enjoy the luxury of walk-in closets, providing ample storage space for your belongings. Our community also includes a sparkling swimming pool, heated spa, and pet-friendly walking area, ensuring a comprehensive living experience. Discover your new home at McAlister today.",
      "featured_image": "https://irp.cdn-website.com/493be48b/dms3rep/multi/05_qwwlpx.webp",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-d4d4-726c-aecc-489665d83699",
        "storage_key": "property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "McAlister | Apartments For Rent Near Me with Walk-In Closets",
      "seo_description": "Explore McAlister's apartments for rent near me with walk-in closets. Enjoy modern amenities, a prime Webster, TX location, and spacious living with ample storage.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-webster-tx-near-memorial-hermann",
      "search_query": "Apartments For Rent In Webster TX Near Memorial Hermann Southeast Hospital",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Webster TX Near Memorial Hermann Southeast Hospital",
      "h2_subtitle": "Discover convenient living at McAlister, located near Memorial Hermann Southeast Hospital. Enjoy modern amenities and a prime Webster, TX location.",
      "page_copy": "Welcome to McAlister, where our apartments for rent in Webster, TX, offer the perfect location near Memorial Hermann Southeast Hospital. Situated on El Dorado Boulevard, our community provides easy access to I-45 and Baybrook Mall, making it ideal for those seeking convenience and comfort. Each apartment features a spacious floor plan with vaulted ceilings, crown molding, and vinyl plank-style flooring. Enjoy your private balcony or patio, perfect for relaxation. Our community amenities include a sparkling swimming pool, fitness center, and pet-friendly walking area, ensuring a vibrant lifestyle. Discover your new home at McAlister today, just moments from Memorial Hermann Southeast Hospital.",
      "featured_image": "https://irp.cdn-website.com/493be48b/dms3rep/multi/05_qwwlpx.webp",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-d4d4-726c-aecc-489665d83699",
        "storage_key": "property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "McAlister | Apartments For Rent In Webster TX Near Memorial Hermann Southeast Hospital",
      "seo_description": "Explore McAlister's apartments for rent in Webster, TX, near Memorial Hermann Southeast Hospital. Enjoy modern amenities and a prime location for convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-in-webster-tx-near-team-health",
      "search_query": "Apartments For Rent In Webster TX Near Team Health",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Webster TX Near Team Health",
      "h2_subtitle": "Experience convenient living at McAlister, located near Team Health. Enjoy modern amenities and a prime Webster, TX location for your lifestyle needs.",
      "page_copy": "Welcome to McAlister, where our apartments for rent in Webster, TX, offer an ideal location near Team Health. Situated on El Dorado Boulevard, our community provides easy access to I-45 and Baybrook Mall, making it perfect for those seeking convenience and comfort. Each apartment features a spacious floor plan with vaulted ceilings, crown molding, and vinyl plank-style flooring. Enjoy your private balcony or patio, perfect for relaxation. Our community amenities include a sparkling swimming pool, fitness center, and pet-friendly walking area, ensuring a vibrant lifestyle. Discover your new home at McAlister today, just moments from Team Health.",
      "featured_image": "https://irp.cdn-website.com/493be48b/dms3rep/multi/05_qwwlpx.webp",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-d4d4-726c-aecc-489665d83699",
        "storage_key": "property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "McAlister | Apartments For Rent In Webster TX Near Team Health",
      "seo_description": "Explore McAlister's apartments for rent in Webster, TX, near Team Health. Enjoy modern amenities and a prime location for convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-webster-tx-near-hca-houston",
      "search_query": "Apartments For Rent In Webster TX Near HCA Houston Healthcare Southeast",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Webster TX Near HCA Houston Healthcare Southeast",
      "h2_subtitle": "Enjoy convenient living at McAlister, located near HCA Houston Healthcare Southeast. Experience modern amenities and a prime Webster, TX location.",
      "page_copy": "Welcome to McAlister, where our apartments for rent in Webster, TX, offer an ideal location near HCA Houston Healthcare Southeast. Situated on El Dorado Boulevard, our community provides easy access to I-45 and Baybrook Mall, making it perfect for those seeking convenience and comfort. Each apartment features a spacious floor plan with vaulted ceilings, crown molding, and vinyl plank-style flooring. Enjoy your private balcony or patio, perfect for relaxation. Our community amenities include a sparkling swimming pool, fitness center, and pet-friendly walking area, ensuring a vibrant lifestyle. Discover your new home at McAlister today, just moments from HCA Houston Healthcare Southeast.",
      "featured_image": "https://irp.cdn-website.com/493be48b/dms3rep/multi/05_qwwlpx.webp",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-d4d4-726c-aecc-489665d83699",
        "storage_key": "property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "McAlister | Apartments For Rent In Webster TX Near HCA Houston Healthcare Southeast",
      "seo_description": "Explore McAlister's apartments for rent in Webster, TX, near HCA Houston Healthcare Southeast. Enjoy modern amenities and a prime location for convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-webster-tx-near-gastro",
      "search_query": "Apartments For Rent In Webster TX Near Gastroenterology",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Webster TX Near Gastroenterology",
      "h2_subtitle": "Experience convenient living at McAlister, located near gastroenterology services. Enjoy modern amenities and a prime Webster, TX location.",
      "page_copy": "Welcome to McAlister, where our apartments for rent in Webster, TX, offer an ideal location near gastroenterology services. Situated on El Dorado Boulevard, our community provides easy access to I-45 and Baybrook Mall, making it perfect for those seeking convenience and comfort. Each apartment features a spacious floor plan with vaulted ceilings, crown molding, and vinyl plank-style flooring. Enjoy your private balcony or patio, perfect for relaxation. Our community amenities include a sparkling swimming pool, fitness center, and pet-friendly walking area, ensuring a vibrant lifestyle. Discover your new home at McAlister today, just moments from gastroenterology services.",
      "featured_image": "https://irp.cdn-website.com/493be48b/dms3rep/multi/05_qwwlpx.webp",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-d4d4-726c-aecc-489665d83699",
        "storage_key": "property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "McAlister | Apartments For Rent In Webster TX Near Gastroenterology",
      "seo_description": "Explore McAlister's apartments for rent in Webster, TX, near gastroenterology services. Enjoy modern amenities and a prime location for convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-in-webster-tx-near-san-jacinto",
      "search_query": "Apartments For Rent In Webster TX Near San Jacinto College: Central Campus",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Webster TX Near San Jacinto College: Central Campus",
      "h2_subtitle": "Experience convenient living at McAlister, located near San Jacinto College: Central Campus. Enjoy modern amenities and a prime Webster, TX location.",
      "page_copy": "Welcome to McAlister, where our apartments for rent in Webster, TX, offer an ideal location near San Jacinto College: Central Campus. Situated on El Dorado Boulevard, our community provides easy access to I-45 and Baybrook Mall, making it perfect for those seeking convenience and comfort. Each apartment features a spacious floor plan with vaulted ceilings, crown molding, and vinyl plank-style flooring. Enjoy your private balcony or patio, perfect for relaxation. Our community amenities include a sparkling swimming pool, fitness center, and pet-friendly walking area, ensuring a vibrant lifestyle. Discover your new home at McAlister today, just moments from San Jacinto College: Central Campus.",
      "featured_image": "https://irp.cdn-website.com/493be48b/dms3rep/multi/05_qwwlpx.webp",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-d4d4-726c-aecc-489665d83699",
        "storage_key": "property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "McAlister | Apartments For Rent In Webster TX Near San Jacinto College: Central Campus",
      "seo_description": "Explore McAlister's apartments for rent in Webster, TX, near San Jacinto College: Central Campus. Enjoy modern amenities and a prime location for convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-webster-tx-near-u-of-houston-clear-lake",
      "search_query": "Apartments For Rent In Webster TX Near University of Houston-Clear Lake",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Webster TX Near University of Houston-Clear Lake",
      "h2_subtitle": "Enjoy convenient living at McAlister, located near University of Houston-Clear Lake. Experience modern amenities and a prime Webster, TX location.",
      "page_copy": "Welcome to McAlister, where our apartments for rent in Webster, TX, offer an ideal location near the University of Houston-Clear Lake. Situated on El Dorado Boulevard, our community provides easy access to I-45 and Baybrook Mall, making it perfect for those seeking convenience and comfort. Each apartment features a spacious floor plan with vaulted ceilings, crown molding, and vinyl plank-style flooring. Enjoy your private balcony or patio, perfect for relaxation. Our community amenities include a sparkling swimming pool, fitness center, and pet-friendly walking area, ensuring a vibrant lifestyle. Discover your new home at McAlister today, just moments from the University of Houston-Clear Lake.",
      "featured_image": "https://irp.cdn-website.com/493be48b/dms3rep/multi/05_qwwlpx.webp",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-d4d4-726c-aecc-489665d83699",
        "storage_key": "property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "McAlister | Apartments For Rent In Webster TX Near University of Houston-Clear Lake",
      "seo_description": "Explore McAlister's apartments for rent in Webster, TX, near University of Houston-Clear Lake. Enjoy modern amenities and a prime location for convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-webster-tx-near-san-jacinto",
      "search_query": "Apartments For Rent In Webster TX Near San Jacinto College South",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Webster TX Near San Jacinto College South",
      "h2_subtitle": "Experience convenient living at McAlister, located near San Jacinto College South. Enjoy modern amenities and a prime Webster, TX location.",
      "page_copy": "Welcome to McAlister, where our apartments for rent in Webster, TX, offer an ideal location near San Jacinto College South. Situated on El Dorado Boulevard, our community provides easy access to I-45 and Baybrook Mall, making it perfect for those seeking convenience and comfort. Each apartment features a spacious floor plan with vaulted ceilings, crown molding, and vinyl plank-style flooring. Enjoy your private balcony or patio, perfect for relaxation. Our community amenities include a sparkling swimming pool, fitness center, and pet-friendly walking area, ensuring a vibrant lifestyle. Discover your new home at McAlister today, just moments from San Jacinto College South.",
      "featured_image": "https://irp.cdn-website.com/493be48b/dms3rep/multi/05_qwwlpx.webp",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-d4d4-726c-aecc-489665d83699",
        "storage_key": "property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "McAlister | Apartments For Rent In Webster TX Near San Jacinto College South",
      "seo_description": "Explore McAlister's apartments for rent in Webster, TX, near San Jacinto College South. Enjoy modern amenities and a prime location for convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-webster-tx-near-remington-college",
      "search_query": "Apartments For Rent In Webster TX Near Remington College - North Houston Satellite Location",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Webster TX Near Remington College - North Houston Satellite Location",
      "h2_subtitle": "Enjoy convenient living at McAlister, located near Remington College - North Houston Satellite Location. Experience modern amenities and a prime Webster, TX location.",
      "page_copy": "Welcome to McAlister, where our apartments for rent in Webster, TX, offer an ideal location near Remington College - North Houston Satellite Location. Situated on El Dorado Boulevard, our community provides easy access to I-45 and Baybrook Mall, making it perfect for those seeking convenience and comfort. Each apartment features a spacious floor plan with vaulted ceilings, crown molding, and vinyl plank-style flooring. Enjoy your private balcony or patio, perfect for relaxation. Our community amenities include a sparkling swimming pool, fitness center, and pet-friendly walking area, ensuring a vibrant lifestyle. Discover your new home at McAlister today, just moments from Remington College - North Houston Satellite Location.",
      "featured_image": "https://irp.cdn-website.com/493be48b/dms3rep/multi/05_qwwlpx.webp",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-d4d4-726c-aecc-489665d83699",
        "storage_key": "property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "McAlister | Apartments For Rent In Webster TX Near Remington College - North Houston Satellite Location",
      "seo_description": "Explore McAlister's apartments for rent in Webster, TX, near Remington College - North Houston Satellite Location. Enjoy modern amenities and a prime location for convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-in-webster-tx-near-alvin-community",
      "search_query": "Apartments For Rent In Webster TX Near Alvin Community College",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Webster TX Near Alvin Community College",
      "h2_subtitle": "Experience convenient living at McAlister, located near Alvin Community College. Enjoy modern amenities and a prime Webster, TX location.",
      "page_copy": "Welcome to McAlister, where our apartments for rent in Webster, TX, offer an ideal location near Alvin Community College. Situated on El Dorado Boulevard, our community provides easy access to I-45 and Baybrook Mall, making it perfect for those seeking convenience and comfort. Each apartment features a spacious floor plan with vaulted ceilings, crown molding, and vinyl plank-style flooring. Enjoy your private balcony or patio, perfect for relaxation. Our community amenities include a sparkling swimming pool, fitness center, and pet-friendly walking area, ensuring a vibrant lifestyle. Discover your new home at McAlister today, just moments from Alvin Community College.",
      "featured_image": "https://irp.cdn-website.com/493be48b/dms3rep/multi/05_qwwlpx.webp",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-d4d4-726c-aecc-489665d83699",
        "storage_key": "property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "McAlister | Apartments For Rent In Webster TX Near Alvin Community College",
      "seo_description": "Explore McAlister's apartments for rent in Webster, TX, near Alvin Community College. Enjoy modern amenities and a prime location for convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-webster-tx-near-whitcomb",
      "search_query": "Apartments For Rent In Webster TX Near Whitcomb Elementary School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Webster TX Near Whitcomb Elementary School",
      "h2_subtitle": "Enjoy family-friendly living at McAlister, just 2.4 km from Whitcomb Elementary School. Discover spacious floor plans and modern amenities in Webster, TX.",
      "page_copy": "Welcome to McAlister, where our apartments for rent in Webster, TX, offer the perfect location for families near Whitcomb Elementary School. Located just 2.4 km away, our community provides easy access to quality education and a supportive school district. Choose from our spacious 1 and 2-bedroom floor plans, each featuring vaulted ceilings, crown molding, and vinyl plank-style flooring. Enjoy your private balcony or patio, ideal for family relaxation. Our community amenities include a sparkling swimming pool, fitness center, and pet-friendly walking area, ensuring a vibrant lifestyle for all ages. Discover your new family home at McAlister today, conveniently located near Whitcomb Elementary School.",
      "featured_image": "https://irp.cdn-website.com/493be48b/dms3rep/multi/05_qwwlpx.webp",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-d4d4-726c-aecc-489665d83699",
        "storage_key": "property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "McAlister | Apartments For Rent In Webster TX Near Whitcomb Elementary School",
      "seo_description": "Explore McAlister's family-friendly apartments for rent in Webster, TX, near Whitcomb Elementary School. Enjoy spacious floor plans and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-in-webster-tx-near-clear-lake",
      "search_query": "Apartments For Rent In Webster TX Near Clear Lake Intermediate School",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Webster TX Near Clear Lake Intermediate School",
      "h2_subtitle": "Enjoy family-friendly living at McAlister, just 1.9 km from Clear Lake Intermediate School. Explore spacious floor plans and modern amenities in Webster, TX.",
      "page_copy": "Welcome to McAlister, where our apartments for rent in Webster, TX, offer an ideal location for families near Clear Lake Intermediate School. Located just 1.9 km away, our community provides easy access to quality education within the Clear Creek Independent School District. Choose from our spacious 1 and 2-bedroom floor plans, each featuring vaulted ceilings, crown molding, and vinyl plank-style flooring. Enjoy your private balcony or patio, perfect for family relaxation. Our community amenities include a sparkling swimming pool, fitness center, and pet-friendly walking area, ensuring a vibrant lifestyle for all ages. Discover your new family home at McAlister today, conveniently located near Clear Lake Intermediate School.",
      "featured_image": "https://irp.cdn-website.com/493be48b/dms3rep/multi/05_qwwlpx.webp",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-d4d4-726c-aecc-489665d83699",
        "storage_key": "property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "McAlister | Apartments For Rent In Webster TX Near Clear Lake Intermediate School",
      "seo_description": "Explore McAlister's family-friendly apartments for rent in Webster, TX, near Clear Lake Intermediate School. Enjoy spacious floor plans and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-webster-tx-near-clear-lake-high-school",
      "search_query": "Apartments For Rent In Webster TX Near Clear Lake High School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Webster TX Near Clear Lake High School",
      "h2_subtitle": "Enjoy family-friendly living at McAlister, just 5.7 km from Clear Lake High School. Discover spacious floor plans and modern amenities in Webster, TX.",
      "page_copy": "Welcome to McAlister, where our apartments for rent in Webster, TX, offer an ideal location for families near Clear Lake High School. Located just 5.7 km away, our community provides easy access to quality education within the Clear Creek Independent School District. Choose from our spacious 1 and 2-bedroom floor plans, each featuring vaulted ceilings, crown molding, and vinyl plank-style flooring. Enjoy your private balcony or patio, perfect for family relaxation. Our community amenities include a sparkling swimming pool, fitness center, and pet-friendly walking area, ensuring a vibrant lifestyle for all ages. Discover your new family home at McAlister today, conveniently located near Clear Lake High School.",
      "featured_image": "https://irp.cdn-website.com/493be48b/dms3rep/multi/05_qwwlpx.webp",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-d4d4-726c-aecc-489665d83699",
        "storage_key": "property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "McAlister | Apartments For Rent In Webster TX Near Clear Lake High School",
      "seo_description": "Explore McAlister's family-friendly apartments for rent in Webster, TX, near Clear Lake High School. Enjoy spacious floor plans and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-webster-tx-near-clear-lake",
      "search_query": "Apartments For Rent In Webster TX Near Clear Lake Neighborhood",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Webster TX Near Clear Lake Neighborhood",
      "h2_subtitle": "McAlister offers a blend of comfort and convenience in Webster, TX. Explore our upscale one and two-bedroom apartments with premium amenities today.",
      "page_copy": "Welcome to McAlister, where you can find exceptional apartments for rent in Webster TX near Clear Lake Neighborhood. Our community features a variety of upscale interior and community amenities designed to enhance your living experience. Located at 450 El Dorado Blvd, McAlister provides easy access to the vibrant Clear Lake area, offering both tranquility and convenience. Whether you're looking for a cozy one-bedroom or a spacious two-bedroom apartment, McAlister has the perfect home for you. Enjoy the best of Webster living with our first-class amenities and prime location.",
      "featured_image": "https://irp.cdn-website.com/493be48b/dms3rep/multi/05_qwwlpx.webp",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-d4d4-726c-aecc-489665d83699",
        "storage_key": "property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "McAlister | Apartments For Rent In Webster TX Near Clear Lake Neighborhood",
      "seo_description": "Explore McAlister's apartments for rent in Webster TX near Clear Lake Neighborhood. Enjoy upscale living with premium amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "page_item_url": "discover-pet-friendly-apartments-rent-webster-tx",
      "search_query": "Pet Friendly Apartments For Rent In Webster TX Near Clear Lake",
      "category": "Pet-Friendly",
      "h1_title": "Discover Pet Friendly Apartments For Rent In Webster TX Near Clear Lake",
      "h2_subtitle": "McAlister offers a welcoming environment for you and your furry friends. Enjoy modern amenities and a prime location near Clear Lake in Webster, TX.",
      "page_copy": "Welcome to McAlister, where comfort meets convenience in our pet friendly apartments for rent in Webster TX near Clear Lake. Our community is designed to cater to both you and your pets, offering spacious one and two-bedroom layouts with upscale interiors. Located at 450 El Dorado Blvd, Webster, TX, McAlister features a variety of amenities that enhance your living experience, including pet-friendly spaces and modern conveniences. Whether you're taking a stroll with your pet or enjoying the vibrant community, McAlister is the perfect place to call home. Experience first-class living in a location that provides easy access to the best of Webster and the scenic beauty of Clear Lake.",
      "featured_image": "https://irp.cdn-website.com/493be48b/dms3rep/multi/05_qwwlpx.webp",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-d4d4-726c-aecc-489665d83699",
        "storage_key": "property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "McAlister | Pet Friendly Apartments For Rent In Webster TX Near Clear Lake",
      "seo_description": "Explore McAlister's pet friendly apartments for rent in Webster TX near Clear Lake. Enjoy modern amenities and a prime location for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5682633027616768",
      "source": "custom",
      "page_item_url": "discover-luxury-pet-friendly-apartments-rent-webster-tx",
      "search_query": "Luxury Pet Friendly Apartments For Rent In Webster TX Near Clear Lake Neighborhood",
      "category": "Pet-Friendly",
      "h1_title": "Discover Luxury Pet Friendly Apartments For Rent In Webster TX Near Clear Lake Neighborhood",
      "h2_subtitle": "Experience the perfect blend of comfort and convenience at McAlister. Our upscale apartments in Webster, TX, offer a pet-friendly environment with top-notch amenities.",
      "page_copy": "At McAlister, we offer luxury pet friendly apartments for rent in Webster TX near Clear Lake Neighborhood, designed to provide you with the ultimate living experience. Our one and two-bedroom apartments feature modern interiors, ensuring a comfortable and stylish home for you and your furry friends. Enjoy the convenience of living in a vibrant community with easy access to local attractions and essential services.\n\nOur community amenities are tailored to enhance your lifestyle, with features such as a state-of-the-art fitness center, a sparkling swimming pool, and beautifully landscaped grounds. McAlister is committed to providing a welcoming environment for both you and your pets, making it the ideal choice for those seeking luxury pet friendly apartments for rent in Webster TX near Clear Lake Neighborhood. Discover the perfect home that meets all your needs and more at McAlister.",
      "featured_image": "https://irp.cdn-website.com/493be48b/dms3rep/multi/05_qwwlpx.webp",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-d4d4-726c-aecc-489665d83699",
        "storage_key": "property/5682633027616768/019f6c0f-d4d4-726c-aecc-489665d83699.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "McAlister | Luxury Pet Friendly Apartments For Rent In Webster TX Near Clear Lake Neighborhood",
      "seo_description": "Explore McAlister's luxury pet friendly apartments for rent in Webster TX near Clear Lake Neighborhood. Enjoy upscale living with top amenities for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2176"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376470977"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a39\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a39\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4600727"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KW38NLC"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443872082"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "30ccbdae11f158e1"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/dzlpo769wg4"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "346-676-1352"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlliVVR4aDYzeXpDSkMrVS85QzI1SFE9PSIsInZhbHVlIjoiZzQvMzZGRUE1ZXVwVTR3b0NaOXFkZz09IiwibWFjIjoiNjQxYjZlMmUxMjhiZTQ5MzEzMmZmMzkyY2IyODA1MjBlOWFmMTMzNDhlZjQ5MmNiMzU1ZDNjYzYyYTYyZWM0NyJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2176",
  "custom_repli_id": "2376470977",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a39\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a39\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4600727",
  "custom_google_gtm_id": "GTM-KW38NLC",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443872082",
  "custom_knock_community_id": "30ccbdae11f158e1",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/dzlpo769wg4",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "346-676-1352",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlliVVR4aDYzeXpDSkMrVS85QzI1SFE9PSIsInZhbHVlIjoiZzQvMzZGRUE1ZXVwVTR3b0NaOXFkZz09IiwibWFjIjoiNjQxYjZlMmUxMjhiZTQ5MzEzMmZmMzkyY2IyODA1MjBlOWFmMTMzNDhlZjQ5MmNiMzU1ZDNjYzYyYTYyZWM0NyJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "ecdc8611-e375-4589-b757-ea90917fdeda",
  "custom_audioeye_site_hash": "d87229ff3fda5fe0dca035174d3faa63"
};

export const generatedAt = '2026-11-03T20:34:16.846Z';
